<template>
  <div class="danmu-console">
    <div class="laplace-shell events-list-wrap in-dashboard panel-list-wrap scheme-light" data-theme="light">
      <header class="laplace-topbar group-toolbar">
        <div class="brand" title="LAPLACE Chat">
          <span class="brand-mark">TX</span>
          <span class="brand-text">TX Chat</span>
        </div>

        <el-input
          v-model="keyword"
          class="laplace-search"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          placeholder="搜索..."
        ></el-input>

        <div class="top-guard-rank" @mouseenter="openGuardRank" @mouseleave="closeTopRankPanel('guard')">
          <button class="top-rank-toggle top-rank-toggle--guard" type="button" :title="guardTopTitle" @click.stop="toggleTopRankPanel('guard')">
            <i :class="guardRankLoading ? 'el-icon-loading' : 'fa fa-ship'"></i>
            <span>舰长</span>
            <strong v-if="guardDisplayTotal">{{ guardDisplayTotal }}</strong>
          </button>
          <transition name="rank-popover">
          <div v-if="guardTopExpanded" class="top-popover top-guard-popover" :class="{ 'top-popover--pinned': guardRankPinned }">
            <div class="top-popover-head">
              <strong>舰长列表 <span>{{ guardRankPinned ? "全部" : "前10" }}</span></strong>
              <div class="guard-rank-sort" title="舰长列表排序方式">
                <button type="button" :class="{ active: guardRankSort === 'default' }" @click.stop="guardRankSort = 'default'">默认</button>
                <button type="button" :class="{ active: guardRankSort === 'days' }" @click.stop="guardRankSort = 'days'">陪伴天数</button>
              </div>
              <button type="button" :disabled="guardRankLoading" title="刷新舰长列表" @click="fetchGuardRank(true)"><i :class="guardRankLoading ? 'el-icon-loading' : 'el-icon-refresh'"></i></button>
              <button v-if="!guardRankPinned" type="button" title="展开全部舰长" @click.stop="expandTopRankPanel('guard')"><i class="el-icon-bottom"></i></button>
              <button v-if="guardRankPinned" type="button" title="关闭舰长列表" @click.stop="closePinnedTopRankPanel('guard')"><i class="el-icon-close"></i></button>
            </div>
            <div class="top-popover-list slim-scrollbar">
              <div v-if="guardRankError" class="top-popover-state error">{{ guardRankError }}</div>
              <transition-group name="rank-row-flow" tag="div" class="top-popover-rows">
                <div v-for="(guard, index) in visibleTopGuardList" :key="'guard-rank-full-' + (guard.uid || guard.username || index)" class="top-popover-row top-popover-row--guard-rank" :title="guardUserTitle(guard)">
                  <span class="top-rank-index">{{ guard.rank || index + 1 }}</span>
                  <img class="top-rank-avatar user-avatar-link" :src="guardAvatar(guard)" referrerpolicy="no-referrer" @click.stop="openUserPage(guard.uid)" @error="hideBrokenImage" />
                  <span class="top-popover-name">{{ guardExportName(guard) || guard.uid || "未知用户" }}</span>
                  <fans-medal :medal="guardMedal(guard)" :perk-level="guardPerkLevel(guard)"></fans-medal>
                  <strong class="top-guard-days">{{ guard.companionDaysText || guard.companion_days ? (guard.companionDaysText || guard.companion_days) + "天" : "-" }}</strong>
                </div>
              </transition-group>
              <empty-line v-if="!guardRankError && !topGuardList.length" text="暂无舰长数据"></empty-line>
            </div>
          </div>
          </transition>
        </div>

        <div class="top-day-rank" @mouseenter="openDayRank" @mouseleave="closeTopRankPanel('day')">
          <button class="top-rank-toggle top-rank-toggle--day" type="button" :title="dayRankTitle" @click.stop="toggleTopRankPanel('day')">
            <i :class="dayRankLoading ? 'el-icon-loading' : 'el-icon-medal'"></i>
            <span>日榜</span>
            <strong v-if="topDayRank.length">{{ topDayRank.length }}</strong>
          </button>
          <transition name="rank-popover">
          <div v-if="dayRankExpanded" class="top-popover top-day-popover" :class="{ 'top-popover--pinned': dayRankPinned }">
            <div class="top-popover-head">
              <strong>当前日榜 <span>{{ dayRankPinned ? "全部" : "前10" }}</span></strong>
              <button type="button" title="刷新日榜" @click="fetchDayRank"><i class="el-icon-refresh"></i></button>
              <button v-if="!dayRankPinned" type="button" title="展开全部日榜" @click.stop="expandTopRankPanel('day')"><i class="el-icon-bottom"></i></button>
              <button v-if="dayRankPinned" type="button" title="关闭日榜" @click.stop="closePinnedTopRankPanel('day')"><i class="el-icon-close"></i></button>
            </div>
            <div class="top-popover-list slim-scrollbar">
              <div v-if="dayRankLoading" class="top-popover-state">
                <i class="el-icon-loading"></i>
                <span>日榜加载中</span>
              </div>
              <div v-else-if="dayRankError" class="top-popover-state error">{{ dayRankError }}</div>
              <transition-group name="rank-row-flow" tag="div" class="top-popover-rows">
                <div v-for="(item, index) in visibleTopDayRank" :key="'day-full-' + (item.uid || item.name || index)" class="top-popover-row">
                  <span class="top-rank-index">{{ index + 1 }}</span>
                  <img class="top-rank-avatar user-avatar-link" :src="item.avatar || NO_FACE" referrerpolicy="no-referrer" @click.stop="openUserPage(item.uid)" @error="hideBrokenImage" />
                  <span class="top-popover-name">{{ item.name || item.username || "未知用户" }}</span>
                  <strong>{{ dayRankValueText(item) }}</strong>
                </div>
              </transition-group>
              <empty-line v-if="!topDayRank.length" text="暂无日榜数据"></empty-line>
            </div>
          </div>
          </transition>
        </div>

        <div class="top-online-rank" :class="{ 'top-online-rank--compact': !onlineRankPreviewVisible }" @mouseenter="openOnlineRank" @mouseleave="closeTopRankPanel('online')">
          <button class="top-rank-toggle" type="button" :title="onlineRankTitle" @click.stop="toggleTopRankPanel('online')">
            <i :class="onlineRankLoading ? 'el-icon-loading' : 'el-icon-s-data'"></i>
            <span>在线榜</span>
            <strong v-if="topOnlineRank.length">{{ topOnlineRank.length }}</strong>
          </button>
          <div v-if="onlineRankPreviewVisible" class="top-rank-preview top-rank-preview--online">
            <div
              v-for="(item, index) in topOnlinePreview"
              :key="'online-preview-' + (item.uid || item.name || index)"
              class="top-rank-user top-rank-user--online"
              :title="onlineRankPreviewTitle(item, index)"
            >
              <span class="top-rank-preview-index">{{ index + 1 }}</span>
              <img class="top-rank-avatar user-avatar-link" :src="item.avatar || NO_FACE" referrerpolicy="no-referrer" @click.stop="openUserPage(item.uid)" @error="hideBrokenImage" />
              <span class="top-rank-name">{{ item.name || item.username || "未知用户" }}</span>
              <strong class="top-rank-value">{{ formatNumber(item.value || 0) }}</strong>
            </div>
          </div>
          <transition name="rank-popover">
          <div v-if="onlineRankExpanded" class="top-popover top-online-popover" :class="{ 'top-popover--pinned': onlineRankPinned }">
            <div class="top-popover-head">
              <strong>当前在线榜 <span>{{ onlineRankPinned ? "全部" : "前10" }}</span></strong>
              <button type="button" :disabled="onlineRankLoading" title="刷新在线榜" @click="fetchOnlineRank(true)"><i :class="onlineRankLoading ? 'el-icon-loading' : 'el-icon-refresh'"></i></button>
              <button v-if="!onlineRankPinned" type="button" title="展开全部在线榜" @click.stop="expandTopRankPanel('online')"><i class="el-icon-bottom"></i></button>
              <button v-if="onlineRankPinned" type="button" title="关闭在线榜" @click.stop="closePinnedTopRankPanel('online')"><i class="el-icon-close"></i></button>
            </div>
            <div class="top-popover-list slim-scrollbar">
              <div v-if="onlineRankLoading" class="top-popover-state">
                <i class="el-icon-loading"></i>
                <span>在线榜加载中</span>
              </div>
              <div v-else-if="onlineRankError" class="top-popover-state error">{{ onlineRankError }}</div>
              <transition-group name="rank-row-flow" tag="div" class="top-popover-rows">
                <div v-for="(item, index) in visibleTopOnlineRank" :key="'online-full-' + (item.uid || item.name || index)" class="top-popover-row">
                  <span class="top-rank-index">{{ index + 1 }}</span>
                  <img class="top-rank-avatar user-avatar-link" :src="item.avatar || NO_FACE" referrerpolicy="no-referrer" @click.stop="openUserPage(item.uid)" @error="hideBrokenImage" />
                  <span class="top-popover-name">{{ item.name || item.username || "未知用户" }}</span>
                  <strong>{{ formatNumber(item.value || 0) }}</strong>
                </div>
              </transition-group>
              <empty-line v-if="!onlineRankLoading && !onlineRankError && !topOnlineRank.length" text="暂无在线榜"></empty-line>
            </div>
          </div>
          </transition>
        </div>

        <div class="room-chip" :title="room.title || room.uname || resolvedRoomId">
          <img class="room-avatar user-avatar-link" :src="roomAvatar" referrerpolicy="no-referrer" @click.stop="openLiveRoom" @error="useRoomAvatarFallback" />
          <div>
            <div class="room-name">{{ room.uname || "天选姬_Official" }}</div>
            <div class="room-state">
              <span class="live-dot" :class="{ on: isRoomLive }"></span>
              {{ connectionText }}
            </div>
          </div>
        </div>

        <div class="top-stat"><i class="el-icon-chat-dot-round"></i>{{ formatNumber(visibleDanmu.length) }}条</div>
        <div class="top-stat"><i class="el-icon-star-on"></i>{{ formatNumber(visibleSc.length) }}条</div>
        <div class="top-stat"><i class="el-icon-s-goods"></i>{{ formatNumber(visibleGiftPanelEvents.length) }}条</div>
        <div class="top-stat" title="在线人数"><i class="el-icon-user"></i>{{ onlineCountText }}</div>

        <div class="top-filters">
          <button class="top-filter-toggle" type="button" :class="{ active: todayOnly }" title="只展示今天的弹幕、SC、礼物" @click="todayOnly = !todayOnly">
            今日
          </button>
          <label class="top-filter">
            <span>礼物≥</span>
            <input v-model="giftMinAmount" type="number" min="0" step="0.1" @blur="formatGiftMinAmount" />
            <span class="top-filter-unit">元</span>
          </label>
          <label class="top-filter">
            <span>弹幕</span>
            <input v-model.number="danmuLimit" type="number" min="1" :max="danmuMaxLimit" step="10" @blur="clampPanelLimit('danmu')" />
            <span class="top-filter-unit">条</span>
          </label>
          <label class="top-filter">
            <span>SC</span>
            <input v-model.number="scLimit" type="number" min="1" :max="scMaxLimit" step="5" @blur="clampPanelLimit('sc')" />
            <span class="top-filter-unit">条</span>
          </label>
          <label class="top-filter">
            <span>礼物</span>
            <input v-model.number="giftLimit" type="number" min="1" :max="giftMaxLimit" step="10" @blur="clampPanelLimit('gift')" />
            <span class="top-filter-unit">条</span>
          </label>
        </div>

        <div class="top-actions">
          <el-select v-model="roomInput" size="mini" class="room-select" placeholder="选择直播间" @change="reloadAll">
            <el-option
              v-for="roomOption in roomOptions"
              :key="roomOption.value"
              :label="roomOption.label"
              :value="roomOption.value"
            ></el-option>
          </el-select>
          <el-button size="mini" class="top-refresh-button" icon="el-icon-refresh" :loading="loading || cloudLoading" @click="reloadAll"></el-button>
          <!-- <el-button
            size="mini"
            :type="wsConnected ? 'danger' : 'primary'"
            :icon="wsConnected ? 'el-icon-video-pause' : 'el-icon-video-play'"
            @click="toggleWs"
          ></el-button> -->
          <el-button
            v-if="showBackendFullscreen"
            size="mini"
            class="top-fullscreen-button"
            :icon="backendFullscreen ? 'el-icon-close' : 'el-icon-full-screen'"
            :title="backendFullscreen ? '退出全屏' : '隐藏左侧导航栏'"
            @click="toggleBackendFullscreen"
          >{{ backendFullscreen ? "退出全屏" : "全屏" }}</el-button>
          <el-button size="mini" class="top-doc-button" icon="el-icon-document" @click="guideVisible = true"></el-button>
        </div>
      </header>

      <transition name="alert-slide">
      <div v-if="error || wsError" class="laplace-alert">
        <div class="laplace-alert-content">
          <span v-if="error">{{ error }}</span>
          <span v-if="wsError">{{ wsError }}</span>
        </div>
        <button class="laplace-alert-close" type="button" title="关闭提示" @click="clearTopAlert">
          <i class="el-icon-close"></i>
        </button>
      </div>
      </transition>

      <main class="dashboard-panels">
        <section id="panel-main" class="dashboard-panel panel panel-messages">
          <div class="dashboard-panel-toolbar panel-toolbar">
            <div class="toolbar-header">
              <i class="el-icon-chat-dot-round"></i>
              <strong>{{ formatNumber(visibleDanmu.length) }}</strong>
              <span>条</span>
              <span>Users</span>
              <strong>{{ formatNumber(danmuUserCount) }}</strong>
              <span>{{ formatNumber(liveEvents.length) }}</span>
            </div>
            <!-- <input class="panel-input" disabled placeholder="输入弹幕..." /> -->
            <div class="panel-icons">
              <button class="panel-tool-button" :title="panelOrderTitle('danmu')" @click="togglePanelOrder('danmu')">
                <i :class="panelOrderIcon('danmu')"></i>
              </button>
              <!-- <i class="el-icon-bell"></i>
              <i class="el-icon-s-operation"></i> -->
            </div>
          </div>

          <transition-group ref="danmuList" name="event-flow" tag="div" class="panel-list panel-list--main slim-scrollbar">
            <div
              v-for="item in visibleDanmu"
              :key="item.key"
              :class="eventClass(item, 'normal')"
              :style="eventStyle(item)"
              :data-uid="item.uid"
              :data-timestamp="item.timeMs"
              :title="eventTitle(item)"
            >
              <laplace-avatar
                v-if="showEventAvatar(item)"
                class-name="avatar--sender avatar-alt-outer hidden"
                :item="item"
                :frame="avatarFrameSrc(item)"
              ></laplace-avatar>

              <div class="meta">
                <span class="timestamp tabular-nums hidden">{{ formatClock(item.timeMs) }}</span>
                <laplace-avatar
                  v-if="showEventAvatar(item)"
                  class-name="sender-avatar avatar--sender"
                  :item="item"
                  :frame="avatarFrameSrc(item)"
                ></laplace-avatar>
                <wealth-medal :level="wealthLevel(item)"></wealth-medal>
                <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                <div v-if="userLevel(item)" :class="['user-level', 'user-level--' + userLevel(item)]" :style="{ borderColor: userLevelColor(item) }">
                  <div class="user-level-text" :style="{ color: userLevelColor(item) }">
                    <span class="user-level-name">UL</span>
                    <span class="user-level-figure">{{ userLevel(item) }}</span>
                  </div>
                </div>
                <div class="username" :style="{ color: usernameColor(item) }">
                  <div class="username-text">{{ item.username || "未知用户" }}</div>
                </div>
                <span v-if="currentRank(item)" :class="['current-rank', 'current-rank--' + currentRank(item)]">榜{{ currentRank(item) }}</span>
              </div>

              <span class="message">
                <template v-if="replyName(item)">
                  <span class="reply">
                    <laplace-avatar class-name="reply-avatar avatar--reply inline-flex" :uid="replyUid(item)"></laplace-avatar>
                    <span class="reply-username">{{ replyName(item) }}</span>
                  </span>
                </template>
                <template v-for="(part, index) in messageParts(item)">
                  <img
                    v-if="part.type === 'image'"
                    :key="'img-' + item.key + '-' + index"
                    :class="part.className"
                    :src="part.url"
                    :alt="part.alt || '表情'"
                    referrerpolicy="no-referrer"
                    loading="lazy"
                    @error="hideBrokenImage"
                  />
                  <span v-else :key="'txt-' + item.key + '-' + index">{{ part.value }}</span>
                </template>
              </span>
            </div>
            <empty-line v-if="visibleDanmu.length === 0" key="danmu-empty" text="暂无弹幕"></empty-line>
          </transition-group>

            <div class="entry-strip" :style="entryStripVars">
              <div
                class="entry-strip-resizer"
                title="拖动调整进房列表高度"
                @mousedown="startEntryResize"
              ></div>
              <div class="entry-strip-toolbar">
                <div class="entry-strip-title">
                  <i class="el-icon-s-custom"></i>
                <strong>{{ formatNumber(filteredEntryRoomEvents.length) }}</strong>
                <span>进房</span>
              </div>
              <!-- <span class="entry-strip-status">{{ wsConnected ? "WSS" : cloudStatusText }}</span> -->
            </div>
            <transition-group ref="entryList" name="entry-flow" tag="div" class="entry-strip-list slim-scrollbar">
              <div
                v-for="item in visibleEntryRoomEvents"
                :key="'entry-strip-' + item.key"
                class="entry-strip-row"
                :style="entryStripStyle(item)"
                :title="eventTitle(item)"
              >
                <div class="entry-strip-content">
                  <laplace-avatar v-if="showEventAvatar(item)" class-name="entry-strip-avatar" :item="item"></laplace-avatar>
                  <span class="entry-time tabular-nums">{{ formatClock(item.timeMs) }}</span>
                  <wealth-medal v-if="item.showWealthMedal !== false" :level="wealthLevel(item)"></wealth-medal>
                  <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                  <span class="entry-name" :style="{ color: item.nameColor || '' }">{{ item.username || "未知用户" }}</span>
                  <span class="entry-message" :style="{ color: item.textColor || '' }">{{ sideEventText(item) }}</span>
                </div>
              </div>
              <empty-line v-if="visibleEntryRoomEvents.length === 0" key="entry-empty" text="暂无进房"></empty-line>
            </transition-group>
          </div>
        </section>

        <section id="panel-superchats" class="dashboard-panel panel panel-superchats">
          <div class="dashboard-panel-toolbar panel-toolbar">
            <div class="toolbar-header">
              <i class="el-icon-star-on"></i>
              <span>Super Chat</span>
              <strong>{{ formatNumber(visibleSc.length) }}</strong>
              <span>条</span>
              <span>Users</span>
              <strong>{{ formatNumber(scUserCount) }}</strong>
              <span>{{ formatMoney(scTotal) }}</span>
            </div>
            <div class="panel-icons">
              <button class="panel-tool-button" title="本栏全部已读" @click="markPanelRead('sc')">
                <i class="el-icon-circle-check"></i>
              </button>
              <button class="panel-tool-button" title="取消本栏已读" :disabled="!panelReadCount('sc')" @click="clearPanelRead('sc')">
                <i class="el-icon-refresh-left"></i>
              </button>
              <button class="panel-tool-button" :title="panelOrderTitle('sc')" @click="togglePanelOrder('sc')">
                <i :class="panelOrderIcon('sc')"></i>
              </button>
            </div>
          </div>

          <transition-group ref="scList" name="event-flow" tag="div" class="panel-list panel-list--superchat slim-scrollbar">
            <div
              v-for="item in visibleSc"
              :key="item.key"
              :class="eventClass(item, 'normal')"
              :style="eventStyle(item)"
              :data-uid="item.uid"
              :data-timestamp="item.timeMs"
              :title="eventTitle(item)"
              @dblclick="toggleEventRead(item)"
            >
              <div class="content">
                <div class="top">
                  <laplace-avatar :item="item" :frame="avatarFrameSrc(item)"></laplace-avatar>
                  <laplace-avatar :item="item" :frame="avatarFrameSrc(item)" class-name="avatar-alt-top hidden"></laplace-avatar>
                  <picture v-if="item.guardBackground" class="guard-bg-wrap guard-bg-wrap-alt-top hidden">
                    <img class="guard-bg" :src="item.guardBackground" alt="图标" referrerpolicy="no-referrer" loading="lazy" />
                  </picture>
                  <div class="meta">
                    <div class="username-wrap">
                      <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                      <div class="username">
                        <div class="username-text">{{ item.username || "未知用户" }}</div>
                      </div>
                    </div>
                    <div class="price">
                      <span class="price-currency">CN¥</span>
                      <span class="price-figure">{{ formatMoneyFigure(eventAmount(item)) }}</span>
                    </div>
                    <div class="timestamp-wrap">
                      <i v-if="item.deleted" class="el-icon-warning-outline deleted-badge"></i>
                      <div class="timestamp">{{ relativeTime(item.timeMs) }}</div>
                    </div>
                  </div>
                </div>
                <div class="message">
                  <div class="message-text">
                    <template v-for="(part, index) in messageParts(item)">
                      <img
                        v-if="part.type === 'image'"
                        :key="'sc-img-' + item.key + '-' + index"
                        :class="part.className"
                        :src="part.url"
                        :alt="part.alt || '表情'"
                        referrerpolicy="no-referrer"
                        loading="lazy"
                        @error="hideBrokenImage"
                      />
                      <span v-else :key="'sc-txt-' + item.key + '-' + index">{{ part.value }}</span>
                    </template>
                  </div>
                  <div v-if="item.messageTrans" class="message-translation">译文 {{ item.messageTrans }}</div>
                  <laplace-avatar :item="item" :frame="avatarFrameSrc(item)" class-name="avatar-alt-bottom hidden"></laplace-avatar>
                </div>
              </div>
            </div>
            <empty-line v-if="visibleSc.length === 0" key="sc-empty" text="暂无 SC"></empty-line>
          </transition-group>
        </section>

        <section id="panel-gifts" class="dashboard-panel panel panel-gifts">
          <div class="dashboard-panel-toolbar panel-toolbar">
            <div class="toolbar-header">
              <i class="el-icon-s-goods"></i>
              <strong>{{ formatNumber(visibleGiftPanelEvents.length) }}</strong>
              <span>条</span>
              <span>Users</span>
              <strong>{{ formatNumber(giftUserCount) }}</strong>
              <span>{{ formatMoney(giftTotal) }}</span>
            </div>
            <div class="gift-type-tabs" role="tablist">
              <button
                v-for="tab in giftTypeTabs"
                :key="tab.key"
                :class="{ active: giftTypeFilter === tab.key }"
                type="button"
                @click="giftTypeFilter = tab.key"
              >{{ tab.label }}</button>
            </div>
            <div class="panel-icons">
              <button class="panel-tool-button" title="本栏全部已读" @click="markPanelRead('gift')">
                <i class="el-icon-circle-check"></i>
              </button>
              <button class="panel-tool-button" title="取消本栏已读" :disabled="!panelReadCount('gift')" @click="clearPanelRead('gift')">
                <i class="el-icon-refresh-left"></i>
              </button>
              <button class="panel-tool-button" :title="panelOrderTitle('gift')" @click="togglePanelOrder('gift')">
                <i :class="panelOrderIcon('gift')"></i>
              </button>
            </div>
          </div>

          <div class="guard-summary-strip">
            <div class="guard-summary-main">
              <div class="guard-summary-head">
                <span>{{ guardPeriodText }}</span>
                <button class="guard-refresh-button" type="button" :disabled="guardLoading" @click="fetchGuardStats(true)">
                  <i :class="guardLoading ? 'el-icon-loading' : 'el-icon-refresh'"></i>
                </button>
                <button class="guard-refresh-button" type="button" title="导出本月上舰列表" :disabled="guardLoading" @click="exportGuardListExcel">
                  <i class="el-icon-download"></i>
                </button>
                <button class="guard-refresh-button" type="button" :title="guardExpanded ? '收起本月上舰' : '展开本月上舰'" @click="guardExpanded = !guardExpanded">
                  <i :class="guardExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </button>
              </div>
              <div class="guard-summary-numbers">
                <span><strong>{{ formatNumber(guardShipnum) }}</strong> 舰值</span>
                <span><strong>{{ formatNumber(guardUniqueUsers) }}</strong> 用户</span>
                <span v-for="level in guardSummaryLevelBadges" :key="level.key" class="guard-summary-level" :title="level.title">
                  <span :class="['guard-badge', 'guard-badge--' + level.type]"></span>
                  <strong>{{ formatNumber(level.count) }}</strong>
                </span>
              </div>
            </div>
            <div class="guard-summary-list slim-scrollbar">
              <div v-for="guard in visibleGuardList" :key="guard.uid || guard.username" class="guard-chip" :title="guardUserTitle(guard)">
                <strong>{{ formatNumber(guard.shipnum || 0) }}</strong>
                <span class="guard-chip-name">{{ guard.username || guard.uid || "未知用户" }}</span>
                <span class="guard-chip-level-icons">
                  <span v-for="level in guardLevelBadges(guard)" :key="level.key" :class="['guard-badge', 'guard-badge--' + level.type]" :title="level.title + ' x ' + level.count"></span>
                </span>
              </div>
              <span v-if="guardError" class="guard-empty">{{ guardError }}</span>
              <span v-else-if="!visibleGuardList.length" class="guard-empty">暂无上舰统计</span>
            </div>
            <transition name="guard-panel">
            <div v-if="guardExpanded" class="guard-expanded-panel">
              <div class="guard-expanded-head">
                <strong>本月上舰用户</strong>
                <span>{{ formatNumber(guardList.length) }} 人</span>
              </div>
              <div class="guard-expanded-list slim-scrollbar">
                <div v-for="guard in sortedGuardList" :key="'guard-full-' + (guard.uid || guard.username)" class="guard-expanded-row" :title="guardUserTitle(guard)">
                  <span class="guard-expanded-score">{{ formatNumber(guard.shipnum || 0) }}</span>
                  <img class="guard-expanded-avatar user-avatar-link" :src="guardAvatar(guard)" referrerpolicy="no-referrer" @click.stop="openUserPage(guard.uid)" @error="hideBrokenImage" />
                  <span class="guard-expanded-name">{{ guard.username || guard.uid || "未知用户" }}</span>
                  <span v-for="level in guardLevelBadges(guard)" :key="level.key" class="guard-expanded-stat" :title="level.title">
                    <span :class="['guard-badge', 'guard-badge--' + level.type]"></span>
                    <strong>{{ level.count }}</strong>
                  </span>
                </div>
                <empty-line v-if="!sortedGuardList.length" text="暂无本月上舰"></empty-line>
              </div>
            </div>
            </transition>
          </div>

          <transition-group ref="giftList" name="event-flow" tag="div" class="panel-list panel-list--gift slim-scrollbar">
            <div
              v-for="item in visibleGiftPanelEvents"
              :key="item.key"
              :class="eventClass(item, 'normal')"
              :style="eventStyle(item)"
              :data-uid="item.uid"
              :data-timestamp="item.timeMs"
              :title="eventTitle(item)"
              @dblclick="toggleEventRead(item)"
            >
              <template v-if="item.type === 'gift'">
                <div class="content">
                  <span class="timestamp hidden">{{ formatClock(item.timeMs) }}</span>
                  <div class="top">
                    <laplace-avatar v-if="showEventAvatar(item)" :item="item" :frame="avatarFrameSrc(item)" class-name="sender-avatar avatar--sender"></laplace-avatar>
                    <laplace-avatar v-if="showEventAvatar(item)" :item="item" :frame="avatarFrameSrc(item)" class-name="avatar--sender avatar-alt-top hidden"></laplace-avatar>
                    <wealth-medal :level="wealthLevel(item)"></wealth-medal>
                    <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                    <div class="username">
                      <div class="username-text">{{ item.username || "未知用户" }}</div>
                    </div>
                    <div class="price" v-if="eventAmount(item)">
                      <span class="price-currency">{{ isPaidGift(item) ? "¥" : "" }}</span>
                      <span class="price-figure">{{ giftPriceText(item) }}</span>
                    </div>
                    <span class="gift-image-wrap gift-icon-wrap">
                      <picture class="inline-flex">
                        <img class="gift-icon" :src="giftIconSrc(item)" alt="礼物" referrerpolicy="no-referrer" loading="lazy" @error="useGiftFallback" />
                      </picture>
                    </span>
                  </div>
                  <div class="message">
                    <span class="gift-details-name">{{ giftActionText(item) }}</span>
                    <span class="gift-details" v-if="item.giftAmount && item.giftAmount > 1">
                      <span class="gift-details-symbol">×</span>
                      <span class="gift-details-figure">{{ item.giftAmount }}</span>
                    </span>
                  </div>
                </div>
              </template>

              <template v-else-if="item.type === 'toast'">
                <laplace-avatar :item="item" :guard="item.toastType || guardLevel(item)" :perk-level="toastFrameRank(item)"></laplace-avatar>
                <laplace-avatar :item="item" :guard="item.toastType || guardLevel(item)" :perk-level="toastFrameRank(item)" class-name="avatar-alt-top hidden"></laplace-avatar>
                <div class="content">
                  <div class="username">
                    <div class="username-text">{{ item.username || "未知用户" }}</div>
                  </div>
                  <div class="price">
                    <span class="price-currency">CN¥</span>
                    <span class="price-figure">{{ formatMoneyFigure(eventAmount(item)) }}</span>
                  </div>
                  <div class="message">
                    <span class="toast-details-action">{{ toastAction(item) }}</span>
                    <span class="toast-details-type">{{ item.toastName || item.guardName || "舰长" }}</span>
                    <template v-if="item.toastAmount > 1">
                      <span class="toast-details-symbol">×</span>
                      <span class="toast-details-figure">{{ item.toastAmount }}</span>
                      <span class="toast-details-unit">{{ toastAmountUnitText(item) }}</span>
                    </template>
                    <template v-if="toastTotalDays(item) > 0">
                      <span class="toast-details-total-days-text-before">，已陪伴主播 </span>
                      <b class="toast-details-total-days">{{ toastTotalDays(item) }}</b>
                      <span class="toast-details-total-days-text-after"> 天</span>
                    </template>
                  </div>
                  <laplace-avatar :item="item" :guard="item.toastType || guardLevel(item)" :perk-level="toastFrameRank(item)" class-name="avatar-alt-bottom hidden"></laplace-avatar>
                </div>
              </template>

              <template v-else-if="item.type === 'entry'">
                <picture v-if="entryBackground(item)" class="entry-effect-bg-wrap">
                  <img class="entry-effect-bg" :src="entryBackground(item)" alt="background" referrerpolicy="no-referrer" loading="lazy" />
                </picture>
                <div class="entry-effect-content">
                  <span class="timestamp hidden">{{ formatClock(item.timeMs) }}</span>
                  <div class="meta">
                    <laplace-avatar v-if="showEventAvatar(item)" :item="item"></laplace-avatar>
                    <wealth-medal v-if="item.showWealthMedal !== false" :level="wealthLevel(item)"></wealth-medal>
                    <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                    <div class="username" :style="{ color: item.nameColor || '' }">
                      <div class="username-text">{{ item.username || "未知用户" }}</div>
                    </div>
                  </div>
                  <span class="message" :style="{ color: item.textColor || '' }">{{ sideEventText(item) }}</span>
                </div>
              </template>

              <template v-else-if="item.type === 'lottery' || item.type === 'red-envelope'">
                <div class="content">
                  <div v-if="item.type === 'red-envelope' && redEnvelopeSenderVisible(item)" class="red-envelope-sender" :title="eventTitle(item)">
                    <laplace-avatar :item="item" class-name="red-envelope-avatar"></laplace-avatar>
                    <span class="red-envelope-sender-name">{{ item.username || item.uid || "未知用户" }}</span>
                  </div>
                  <div class="message">{{ sideEventText(item) }}</div>
                  <div class="price" v-if="eventAmount(item)">
                    <span class="price-currency">¥</span>
                    <span class="price-figure">{{ formatMoneyFigure(eventAmount(item)) }}</span>
                  </div>
                  <div class="event-rewards" v-if="item.giftIcon || (item.rewardList && item.rewardList.length)">
                    <img v-if="item.giftIcon" class="reward-icon" :src="item.giftIcon" referrerpolicy="no-referrer" />
                    <span v-for="reward in item.rewardList" :key="reward.id || reward.name" class="reward-chip">
                      <img v-if="reward.icon" :src="reward.icon" referrerpolicy="no-referrer" />
                      <span>{{ reward.name }}</span>
                      <strong v-if="reward.num">×{{ reward.num }}</strong>
                    </span>
                  </div>
                  <div class="lottery-avatars" v-if="lotteryWinners(item).length">
                    <div v-for="winner in lotteryWinners(item)" :key="winner.uid || winner.name" class="lottery-winner" :title="winner.name || winner.uid">
                      <img class="lottery-avatar user-avatar-link" :src="winner.avatar || NO_FACE" referrerpolicy="no-referrer" @click.stop="openUserPage(winner.uid)" @error="hideBrokenImage" />
                      <span>{{ winner.name || winner.uid || "未知用户" }}</span>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else-if="item.type === 'rank'">
                <div class="message rank-event">
                  <strong>{{ item.message || "在线榜更新" }}</strong>
                  <span class="rank-inline" v-for="(rank, index) in item.rankList" :key="rank.uid || rank.name || index">
                    {{ index + 1 }}. {{ rank.name }}
                  </span>
                </div>
              </template>

              <template v-else-if="item.type === 'stat'">
                <div class="message stat-event">
                  <strong>{{ item.message || "直播间数据更新" }}</strong>
                  <span v-if="item.watched">看过 {{ formatNumber(item.watched) }}</span>
                </div>
              </template>

              <template v-else>
                <div class="meta">
                  <laplace-avatar v-if="showEventAvatar(item)" :item="item"></laplace-avatar>
                  <wealth-medal :level="wealthLevel(item)"></wealth-medal>
                  <fans-medal :medal="item.medal" :perk-level="perkLevel(item)"></fans-medal>
                  <span class="action-pill" v-if="item.actionLabel">{{ item.actionLabel }}</span>
                  <span class="username">
                    <span class="username-text">{{ item.username || "未知用户" }}</span>
                  </span>
                </div>
                <span class="message">{{ sideEventText(item) }}</span>
              </template>
            </div>
            <empty-line v-if="visibleGiftPanelEvents.length === 0" key="gift-empty" text="暂无礼物"></empty-line>
          </transition-group>
        </section>
      </main>

      <el-dialog
        title="弹幕控制台使用文档"
        :visible.sync="guideVisible"
        width="900px"
        custom-class="console-guide-dialog"
        append-to-body
      >
        <div class="console-guide-markdown slim-scrollbar" v-html="guideHtml"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pako from "pako";
import * as XLSX from "xlsx";
import { post } from "../axios/request.js";

const DEFAULT_ROOM_ID = 2058234;
const DEFAULT_ANCHOR_UID = 703405;
const ROOM_OPTIONS = Object.freeze([
  { label: "天选姬_Official", value: "2058234" },
  { label: "ElevenOfficial_", value: "25896305" },
  { label: "RO宝_Official", value: "30326232" },
  { label: "爱玛电动车官方账号", value: "433865481" },
]);
const NO_FACE = "https://i0.hdslb.com/bfs/face/member/noface.jpg";
const DEFAULT_COVER = "https://i0.hdslb.com/bfs/live/new_room_cover/f11e5445b76a6b7c3f2fbaa71b796339f54f7325.jpg";
const API_ORIGIN = "https://api.tianxuanji.com";
const TIANXUANJI_FANSDATA_API = `${API_ORIGIN}/api/getfansdata`;
const MAX_LIVE_EVENTS = 600;
const PANEL_EVENT_LIMITS = Object.freeze({
  danmu: 500,
  sc: 200,
  gift: 500,
});
const LAPLACE_WORKERS = "https://workers.laplace.cn";
const LAPLACE_ASSETS = "https://rsrc.laplace.cn";
const GIFT_FALLBACK = `${LAPLACE_ASSETS}/assets/chat/gift-fallback.png`;
const AVATAR_FALLBACK = `${LAPLACE_ASSETS}/assets/chat/no-avatar.jpg`;
const TRANSPARENT_IMAGE = `${LAPLACE_ASSETS}/assets/transparent.png`;
const DANMU_CONSOLE_GUIDE_MD = `# 弹幕控制台使用文档

## 使用者说明

本页面用于直播值守和复盘，把直播间弹幕、SC、礼物、舰长、进房、日榜、在线榜等信息集中在一个控制台里。页面会先加载云端历史事件，再连接实时事件流；直播中可以直接盯三列内容，直播后可以通过筛选和导出做复盘。

## 快速开始

- 进入页面后默认读取房间 \`2058234\` 的历史事件，并自动连接实时 WebSocket。
- 左上搜索框可以输入 UID、用户名、弹幕内容、礼物名或粉丝牌名称，三列会同步过滤。
- 顶部房间输入框可以切换直播间，点击刷新按钮后重新加载配置、历史事件、榜单和实时连接。
- 主播头像旁的红点表示未开播或未获取到在线状态，绿点表示当前直播间在线。
- 顶部弹幕、SC、礼物数字表示当前实际展示的条数，后面统一带“条”。

## 顶部筛选

- 今日按钮开启后，只展示今天产生的弹幕、SC、礼物和相关事件，适合直播当天值守。
- 礼物金额默认 \`1.00\` 元，低于该金额的普通礼物会被隐藏，舰长、红包、天选时刻等仍按事件类型展示。
- 弹幕展示上限最多 \`500\` 条，SC 最多 \`200\` 条，礼物最多 \`500\` 条，防止长时间直播后浏览器卡顿。
- 输入框里的数量控制当前页面渲染多少条最近事件，输入超过上限会自动按上限处理。
- 列顶部的排序按钮可以切换新消息在上或新消息在下，切换后列表会自动移动到最新位置。

## 三列布局

左列为弹幕区，上半部分展示弹幕、用户头像、粉丝牌、荣耀等级、舰长标识和回复信息；下半部分为进房列表，只展示普通入房类事件，隐藏带白色用户名的动效入场事件。

中列为 Super Chat 区，会根据接口返回的金额、颜色、头像框、粉丝牌和消息内容还原 Laplace 风格卡片。SC 支持双击已读，适合值守时逐条处理。

右列为礼物区，包含普通礼物、舰长开通或续费、红包、天选时刻中奖等事件。顶部可以在全部、舰长、礼物之间切换，礼物金额过滤只影响需要按金额隐藏的礼物。

## 进房列表

- 进房列表位于弹幕列底部，可以用鼠标拖动分隔条调整高度。
- 最低高度为 1 行，最高高度为 4 行，方便在直播中留出更多弹幕空间。
- 入房动作会把 B 站数字代号转换成文字，例如 \`1\` 显示为进入直播间，\`2\` 显示为关注了主播，\`3\` 显示为分享了直播间。
- 舰长或带特殊动效的入场背景不会混入普通进房列表，避免遮挡弹幕区。

## 榜单与舰长

- 鼠标移动到舰长、日榜、在线榜按钮上会自动展开前 10 名。
- 点击展开按钮可以固定展开全部列表，并显示关闭按钮；固定展开时最多展示约 20 行并支持滚动。
- 舰长列表优先使用 \`getfansdata\` 获取完整数据，展示头像、粉丝牌、舰长等级和陪伴天数。
- 日榜和在线榜通过后台代理 B 站直播接口，使用后台统一 Bilibili Cookie 获取更完整的数据。
- 在线人数使用在线榜接口轮询更新，页面会避免短暂异常的小数值覆盖正常在线人数。

## 已读与复盘

- 双击 SC 或礼物卡片可以标记为已读，再次双击可以取消已读。
- 已读卡片会出现灰色蒙版和已读角标，方便直播中区分已处理和未处理事件。
- SC 列和礼物列顶部的勾选按钮可以将当前筛选结果全部标记为已读。
- 撤销按钮会取消当前栏位的已读状态，不影响其他栏位。
- 已读信息保存在浏览器本地，按直播间区分，不会修改云端事件数据。

## 导出功能

- 本月上舰区域可以导出 \`.xlsx\` 表格。
- 导出格式包含月份标题、总督列表、提督列表、舰长列表。
- 每个列表包含用户名、UID、本月对应舰种数量。
- 表格字号已放大，适合直接检查或二次整理。

## 建议工作流

- 直播开始前点击刷新，确认云端事件、在线榜、舰长列表都正常加载。
- 值守时开启今日，礼物金额保持 \`1.00\` 元，SC 和礼物处理后双击标记已读。
- 抽奖或红包较多时，礼物区切到全部；只看上舰时切到舰长。
- 直播结束后按需要搜索用户名或 UID，检查特定用户弹幕、SC、礼物和上舰记录。
- 长时间直播时不要把展示条数拉满到无意义的数量，当前页面已限制弹幕 500、SC 200、礼物 500。

## 技术与接口

### 事件来源

- 云端历史事件通过后端 \`/api/danmu/events\` 代理读取。
- 实时事件通过后端配置下发的 LEF WebSocket 地址连接。
- 页面会同时合并云端历史事件和实时事件，并通过事件 ID、时间、UID、消息内容做去重。
- 云端加载后会按类型裁剪，弹幕、SC、礼物分别保留最近上限数量，避免一次性历史数据过多。
- 实时事件保存在 \`liveEvents\`，最大保留 \`MAX_LIVE_EVENTS\` 条。

### 事件类型

- \`message\` 会被归一化为弹幕事件 \`danmu\`。
- \`superchat\` 会被归一化为 \`sc\`，用于中列展示和金额统计。
- \`gift\`、\`toast\`、\`lottery\`、\`red-envelope\` 会进入礼物列。
- \`interaction\`、\`INTERACT_WORD\`、\`WELCOME\`、\`WELCOME_GUARD\` 会进入进房或入场相关逻辑。
- \`online-rank-update\`、\`watched-update\` 等统计类事件不会作为礼物展示。

### Bilibili Cookie

- 后台 Bilibili 登录页负责扫码登录、检测 Cookie 是否有效、保存最新 Cookie。
- 日榜、在线榜、舰长列表等需要登录态的接口统一通过后台 Cookie 发起请求。
- 重新扫码后，新 Cookie 会替换旧 Cookie，后续接口自动使用最新登录态。
- 前端不直接保存 Bilibili Cookie，只调用后台代理接口或使用云端事件数据。

### 榜单接口

- 在线榜使用 B 站直播 \`queryContributionRank\` 接口，参数包含 \`type=online_rank\` 和 \`switch=contribution_rank\`。
- 日榜使用 B 站直播 \`queryContributionRank\` 接口，参数包含 \`type=daily_rank\` 和 \`switch=today_rank\`。
- 舰长列表优先调用 \`https://api.tianxuanji.com/api/getfansdata\`，并分页拉取 \`top3\` 和 \`list\`。
- 后台会处理 WBI 签名、Cookie 请求头、头像兜底、在线人数提取和异常兜底。

### 素材与样式

- 用户头像、主播头像、礼物图标、舰长图标、粉丝牌、荣耀等级图片优先使用接口返回字段。
- 头像和图片都设置 \`referrerpolicy="no-referrer"\`，减少 B 站图片防盗链导致的加载失败。
- 缺失头像会回退到 B 站 noface 或 Laplace 静态资源。
- SC 和礼物卡片的颜色、背景、金额等级、头像框尽量使用接口字段还原。

### 浏览器性能

- 三列渲染有硬上限：弹幕 \`500\` 条、SC \`200\` 条、礼物 \`500\` 条。
- WebSocket 断开后会自动重连，重连间隔会短暂退避，避免频繁失败造成额外压力。
- 在线榜轮询会过滤明显异常的在线人数骤降，防止接口偶发返回小列表时污染顶部数据。
- 已读状态存入浏览器 \`localStorage\`，不会增加后台数据库压力。
- 搜索、今日、金额和类型筛选都在前端计算，适合快速临时排查。
`;

const EmptyLine = {
  props: ["text"],
  render(h) {
    return h("div", { class: "empty-line" }, this.text || "");
  },
};

const LaplaceAvatar = {
  props: {
    item: Object,
    avatar: String,
    uid: [String, Number],
    guard: [String, Number],
    perkLevel: [String, Number],
    frame: String,
    className: String,
    isRoom: Boolean,
    guardLeader: Boolean,
  },
  data() {
    return {
      avatarFailed: false,
      frameFailed: false,
    };
  },
  computed: {
    resolvedItem() {
      return this.item || {};
    },
    resolvedUid() {
      return this.uid || this.resolvedItem.uid || 0;
    },
    userPageUrl() {
      const uid = String(this.resolvedUid || "").trim();
      return /^\d+$/.test(uid) ? `https://space.bilibili.com/${uid}` : "";
    },
    resolvedGuard() {
      const medal = this.resolvedItem.medal || {};
      return Number(this.guard || this.resolvedItem.guardType || medal.guardType || medal.guard_level || 0);
    },
    resolvedPerk() {
      const medal = this.resolvedItem.medal || {};
      return Number(this.perkLevel || medal.resolvedPerkLevel || this.resolvedItem.perkLevel || 1);
    },
    wrapClass() {
      return [
        "avatar-wrap",
        "guard-level--" + this.resolvedGuard,
        "perk-level--" + this.resolvedPerk,
        "guard-leader--" + (this.guardLeader || this.resolvedItem.guardLeader ? "1" : "0"),
        this.className || "",
      ];
    },
    avatarSrc() {
      if (this.avatarFailed) return AVATAR_FALLBACK;
      const value = this.normalizeUrl(this.avatar || this.resolvedItem.avatar || "");
      if (value) return this.resizeBiliImage(value, 320);
      if (this.resolvedUid) {
        return `${LAPLACE_WORKERS}/bilibili/avatar/${this.resolvedUid}?size=320${this.isRoom ? "&isRoom=1" : ""}`;
      }
      return NO_FACE;
    },
    frameSrc() {
      if (this.frameFailed) return "";
      return this.normalizeUrl(this.frame || "");
    },
  },
  methods: {
    normalizeUrl(url) {
      const value = String(url || "").trim();
      if (!value) return "";
      if (value.startsWith("//")) return "https:" + value;
      if (value.startsWith("http://")) return "https://" + value.slice(7);
      if (value.startsWith("bfs/")) return "https://i0.hdslb.com/" + value;
      return value;
    },
    resizeBiliImage(url, size) {
      const value = this.normalizeUrl(url);
      if (!value || value.indexOf("hdslb.com") < 0 || /@\d+w_\d+h/.test(value)) return value;
      return `${value}@${size}w_${size}h`;
    },
    openUserPage(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!this.userPageUrl) return;
      window.open(this.userPageUrl, "_blank", "noopener,noreferrer");
    },
  },
  render(h) {
    const frameNode = this.frameSrc
      ? h("picture", { class: "avatar-frame-wrap" }, [
          h("img", {
            class: "avatar-frame",
            attrs: {
              src: this.frameSrc,
              alt: "头像框",
              referrerpolicy: "no-referrer",
              loading: "lazy",
            },
            on: {
              error: () => {
                this.frameFailed = true;
              },
            },
          }),
        ])
      : h("span", { class: "avatar-frame" });

    return h(
      "span",
      {
        class: this.wrapClass,
        attrs: {
          "data-slot": "avatar",
          "data-uid": this.resolvedUid,
          role: this.userPageUrl ? "link" : null,
          title: this.userPageUrl ? "打开用户主页" : null,
          tabindex: this.userPageUrl ? "0" : null,
        },
        on: {
          click: this.openUserPage,
          keydown: event => {
            if (!this.userPageUrl || !event || (event.key !== "Enter" && event.key !== " ")) return;
            this.openUserPage(event);
          },
        },
      },
      [
        frameNode,
        h("picture", { class: "avatar-img-wrap" }, [
          h("img", {
            class: "avatar",
            attrs: {
              src: this.avatarSrc,
              alt: "头像",
              referrerpolicy: "no-referrer",
              loading: "lazy",
            },
            on: {
              error: () => {
                this.avatarFailed = true;
              },
            },
          }),
        ]),
      ]
    );
  },
};

const WealthMedal = {
  props: {
    level: [String, Number],
    size: String,
  },
  data() {
    return {
      failed: false,
    };
  },
  computed: {
    numericLevel() {
      return Number(this.level || 0);
    },
    medalClass() {
      return [
        "wealth-medal",
        "wealth-medal-lvl--" + this.numericLevel,
        this.size === "sm" ? "wealth-medal-size--sm" : "",
        this.failed ? "wealth-medal-image-failed" : "",
      ];
    },
    src() {
      return this.failed ? TRANSPARENT_IMAGE : `${LAPLACE_WORKERS}/bilibili/wealth-config?level=${this.numericLevel}`;
    },
  },
  render(h) {
    if (!this.numericLevel) return null;
    const children = [
      h("span", { class: "wealth-medal-text" }, String(this.numericLevel)),
      h("picture", [
        h("img", {
          class: this.failed ? "wealth-medal-image-fallback" : "",
          attrs: {
            src: this.src,
            alt: "荣耀勋章",
            referrerpolicy: "no-referrer",
            loading: "lazy",
          },
          on: {
            error: () => {
              this.failed = true;
            },
          },
        }),
      ]),
    ];
    if (this.failed) children.push(h("span", String(this.numericLevel)));
    return h(
      "div",
      {
        class: this.medalClass,
        attrs: {
          "data-medal-lvl": this.numericLevel,
        },
      },
      children
    );
  },
};

const FansMedal = {
  props: {
    medal: Object,
    perkLevel: [String, Number],
    size: String,
  },
  computed: {
    data() {
      return this.medal || {};
    },
    name() {
      return this.data.name || this.data.medal_name || this.data.medalName || "";
    },
    level() {
      return Number(this.data.level || this.data.medal_level || this.data.medalLevel || 0);
    },
    guardType() {
      return Number(this.data.guardType || this.data.guard_level || this.data.guardLevel || 0);
    },
    type() {
      return Number(this.data.type || 0);
    },
    lightened() {
      return this.data.lightened !== undefined ? this.data.lightened : "unknown";
    },
    tier() {
      return Math.ceil(this.level / 10) || 0;
    },
    hasGuard() {
      return this.guardType > 0 || this.type === 1;
    },
    medalClass() {
      return [
        "fans-medal",
        "fans-medal-lvl--" + this.level,
        "fans-medal-tier--" + this.tier,
        "fans-medal-name--" + this.name,
        "fans-medal-lightened--" + this.lightened,
        "fans-medal-type--" + this.type,
        this.hasGuard ? "fans-medal-has-guard fans-medal-has-guard--" + this.guardType : "",
        this.size === "sm" ? "fans-medal-size--sm" : "",
      ];
    },
    guardClass() {
      return [
        "guard-badge-in-fans-medal",
        "guard-badge",
        "guard-badge--" + this.guardType,
        this.perkLevel ? "perk-level--" + this.perkLevel : "",
      ];
    },
  },
  render(h) {
    if (!this.name) return null;
    const contentChildren = [];
    if (this.hasGuard) contentChildren.push(h("div", { class: this.guardClass }));
    contentChildren.push(this.name);
    const children = [h("div", { class: "fans-medal-content" }, contentChildren)];
    if (this.level) children.push(h("div", { class: "fans-medal-level" }, String(this.level)));
    return h(
      "div",
      {
        class: this.medalClass,
        attrs: {
          "data-slot": "fans-medal",
        },
      },
      children
    );
  },
};

const RankBlock = {
  props: {
    title: String,
    items: Array,
    suffix: String,
    money: Boolean,
  },
  methods: {
    valueText(item) {
      if (this.money) return "¥" + Number(item.value || 0).toFixed(2);
      return String(item.value || 0) + (this.suffix || "");
    },
    userPageUrl(item) {
      const uid = String((item && item.uid) || "").trim();
      return /^\d+$/.test(uid) ? `https://space.bilibili.com/${uid}` : "";
    },
    openUserPage(item, event) {
      const url = this.userPageUrl(item);
      if (!url) return;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
  render(h) {
    const rows = (this.items || []).map((item, index) =>
      h(
        "div",
        {
          key: item.uid || item.name || index,
          class: "rank-row",
        },
        [
          h("span", { class: "rank-index" }, String(index + 1)),
          h("img", {
            class: ["rank-avatar", this.userPageUrl(item) ? "user-avatar-link" : ""],
            attrs: {
              src: item.avatar || NO_FACE,
              alt: item.name || "未知用户",
              referrerpolicy: "no-referrer",
              loading: "lazy",
              title: this.userPageUrl(item) ? "打开用户主页" : null,
            },
            on: {
              click: event => this.openUserPage(item, event),
            },
          }),
          h("span", { class: "rank-name" }, item.name || "未知用户"),
          h("strong", this.valueText(item)),
        ]
      )
    );
    if (!rows.length) rows.push(h("div", { class: "empty-line compact" }, "暂无数据"));
    return h("div", { class: "rank-block" }, [h("div", { class: "rank-title" }, this.title || ""), ...rows]);
  },
};

export default {
  name: "appDanmuConsole",
  props: {
    showBackendFullscreen: {
      type: Boolean,
      default: true,
    },
  },
  components: { EmptyLine, RankBlock, LaplaceAvatar, WealthMedal, FansMedal },
  data() {
    return {
      NO_FACE,
      roomOptions: ROOM_OPTIONS,
      roomInput: String(DEFAULT_ROOM_ID),
      room: {},
      wsConfig: null,
      cloudEventUrl: "",
      bridgeUrl: "",
      cloudEvents: [],
      liveEvents: [],
      userCache: {},
      keyword: "",
      sideTab: "gift",
      giftMinAmount: "1.00",
      todayOnly: false,
      danmuMaxLimit: PANEL_EVENT_LIMITS.danmu,
      scMaxLimit: PANEL_EVENT_LIMITS.sc,
      giftMaxLimit: PANEL_EVENT_LIMITS.gift,
      danmuLimit: 120,
      scLimit: 80,
      giftLimit: 320,
      panelOrders: {
        danmu: "desc",
        sc: "desc",
        gift: "desc",
      },
      giftTypeFilter: "all",
      giftTypeTabs: [
        { key: "all", label: "全部" },
        { key: "guard", label: "舰长" },
        { key: "gift", label: "礼物" },
      ],
      readEventMap: {},
      guardStats: null,
      guardList: [],
      guardLoading: false,
      guardError: "",
      guardExpanded: false,
      guardTopExpanded: false,
      guardRankPinned: false,
      guardRankList: [],
      guardRankTotal: 0,
      guardRankSeenToastKeys: {},
      guardRankLoading: false,
      guardRankError: "",
      guardRankSort: "default",
      lastGuardRankAt: 0,
      guardRefreshTimer: null,
      dayRankExpanded: false,
      dayRankPinned: false,
      dayRank: [],
      dayRankLoading: false,
      dayRankError: "",
      onlineRankExpanded: false,
      onlineRankPinned: false,
      onlineRankLoading: false,
      onlineRankError: "",
      onlineRankRefreshTimer: null,
      lastOnlineRankAt: 0,
      backendFullscreen: false,
      guideVisible: false,
      roomAvatarFallbackStage: 0,
      entryListRows: 4,
      entryResizeState: null,
      loading: false,
      cloudLoading: false,
      error: "",
      wsError: "",
      wsStatus: "idle",
      ws: null,
      heartbeatTimer: null,
      reconnectTimer: null,
      lastWsMessageAt: 0,
      lastWsConnectAt: 0,
      cloudRefreshTimer: null,
      currentAddressIndex: 0,
      lastCloudAt: 0,
      popularity: 0,
      watched: 0,
      onlineRank: [],
      autoConnect: true,
      autoRefreshCloud: true,
      unsupportedCompression: false,
      commandCounts: {},
      roomSessionId: 0,
    };
  },
  computed: {
    resolvedRoomId() {
      return Number(this.room.room_id || this.roomInput || DEFAULT_ROOM_ID);
    },
    roomCover() {
      return this.normalizeUrl(this.room.cover) || DEFAULT_COVER;
    },
    roomAvatar() {
      const candidates = this.roomAvatarCandidates();
      return candidates[this.roomAvatarFallbackStage] || NO_FACE;
    },
    isRoomLive() {
      return Number(this.room.live_status || 0) === 1 || this.room.is_live === true;
    },
    wsConnected() {
      return this.wsStatus === "connected";
    },
    connectionText() {
      const map = {
        idle: "实时未连接",
        connecting: "实时连接中",
        connected: "实时已连接",
        closed: "实时已断开",
        error: "实时异常",
      };
      return map[this.wsStatus] || "实时未连接";
    },
    cloudStatusText() {
      if (this.cloudLoading) return "云端事件加载中";
      if (!this.lastCloudAt) return "云端事件尚未加载";
      return "云端更新 " + this.formatClock(this.lastCloudAt);
    },
    allEvents() {
      const map = {};
      const list = [];
      this.liveEvents.concat(this.cloudEvents).forEach(item => {
        if (!item) return;
        const key = item.id || item.key || (item.type + "-" + item.timeMs + "-" + item.uid + "-" + item.message);
        if (map[key]) return;
        map[key] = true;
        list.push(item);
      });
      return list.sort((a, b) => (b.timeMs || 0) - (a.timeMs || 0));
    },
    scopedEvents() {
      return this.todayOnly ? this.allEvents.filter(item => this.isTodayEvent(item)) : this.allEvents;
    },
    danmuEvents() {
      return this.scopedEvents.filter(item => item.type === "danmu");
    },
    scEvents() {
      return this.scopedEvents.filter(item => item.type === "sc");
    },
    giftEvents() {
      return this.scopedEvents.filter(item => this.isGiftPanelEvent(item));
    },
    entryEvents() {
      return this.scopedEvents.filter(item => item.type === "entry");
    },
    sideEvents() {
      return this.scopedEvents.filter(item => ["gift", "toast", "entry", "lottery", "red-envelope", "rank", "stat", "misc"].indexOf(item.type) >= 0);
    },
    giftPanelEvents() {
      return this.giftEvents;
    },
    filteredDanmu() {
      return this.filterEvents(this.danmuEvents);
    },
    filteredSc() {
      return this.filterEvents(this.scEvents);
    },
    filteredGift() {
      return this.filterEvents(this.giftEvents);
    },
    filteredEntry() {
      return this.filterEvents(this.entryEvents);
    },
    filteredSideEvents() {
      return this.filterEvents(this.sideEvents);
    },
    filteredGiftPanelEvents() {
      return this.filterGiftType(this.filterGiftAmount(this.filterEvents(this.giftPanelEvents)));
    },
    filteredEvents() {
      return this.filterEvents(this.scopedEvents);
    },
    visibleDanmu() {
      return this.latestPanelEvents(this.filteredDanmu, "danmu", this.normalizeLimit(this.danmuLimit, 120, PANEL_EVENT_LIMITS.danmu));
    },
    visibleSc() {
      return this.latestPanelEvents(this.filteredSc, "sc", this.normalizeLimit(this.scLimit, 80, PANEL_EVENT_LIMITS.sc));
    },
    visibleGift() {
      return this.filteredGift.slice(0, 100);
    },
    visibleEntry() {
      return this.filteredEntry.slice(0, 120);
    },
    filteredEntryRoomEvents() {
      return this.dedupeEntryRoomEvents(this.filteredEntry.filter(item => this.isEntryRoomListEvent(item)));
    },
    visibleEntryRoomEvents() {
      return this.latestPanelEvents(this.filteredEntryRoomEvents, "danmu", 80);
    },
    visibleSideEvents() {
      return this.filteredSideEvents.slice(0, 160);
    },
    visibleGiftPanelEvents() {
      return this.latestPanelEvents(this.filteredGiftPanelEvents, "gift", this.normalizeLimit(this.giftLimit, 320, PANEL_EVENT_LIMITS.gift));
    },
    visibleEvents() {
      return this.filteredEvents.slice(0, 220);
    },
    stickyEvents() {
      return this.filteredEvents
        .filter(item => this.isStickyEvent(item))
        .slice(0, 12);
    },
    giftTotal() {
      return this.filteredGiftPanelEvents.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    },
    scTotal() {
      return this.scEvents.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    },
    danmuUserCount() {
      return this.uniqueUserCount(this.filteredDanmu);
    },
    scUserCount() {
      return this.uniqueUserCount(this.filteredSc);
    },
    giftUserCount() {
      return this.uniqueUserCount(this.filteredGiftPanelEvents);
    },
    watchedText() {
      const value = this.watched || this.room.watched || this.popularity || this.room.online || 0;
      return this.formatNumber(value);
    },
    onlineCountText() {
      const value = this.popularity || this.room.online || this.room.online_count || this.room.onlineCount || 0;
      return this.formatNumber(value);
    },
    topDanmu() {
      return this.buildRank(this.danmuEvents, item => 1).slice(0, 6);
    },
    topContribution() {
      return this.buildRank(this.giftEvents.concat(this.scEvents), item => Number(item.amount || 0)).slice(0, 6);
    },
    topGift() {
      const map = {};
      this.giftEvents.forEach(item => {
        const name = item.giftName || item.message || "礼物";
        if (!map[name]) map[name] = { name, value: 0, avatar: item.giftIcon || this.roomAvatar };
        map[name].value += Number(item.giftAmount || 1);
      });
      return Object.keys(map).map(key => map[key]).sort((a, b) => b.value - a.value).slice(0, 6);
    },
    topOnlineRank() {
      if (this.onlineRank && this.onlineRank.length) return this.onlineRank;
      const latest = this.allEvents.find(item => item.type === "rank" && item.rankList && item.rankList.length);
      return latest ? latest.rankList : [];
    },
    visibleTopOnlineRank() {
      const rows = this.topOnlineRank || [];
      return this.onlineRankPinned ? rows : rows.slice(0, 10);
    },
    topOnlinePreview() {
      return (this.topOnlineRank || []).slice(0, 3);
    },
    shouldShowOnlineRankPreview() {
      return this.backendFullscreen || !this.showBackendFullscreen || (this.$route && this.$route.path === "/console");
    },
    onlineRankPreviewVisible() {
      return this.shouldShowOnlineRankPreview && this.topOnlinePreview.length > 0;
    },
    topDayRank() {
      return (this.dayRank || []);
    },
    visibleTopDayRank() {
      const rows = this.topDayRank || [];
      return this.dayRankPinned ? rows : rows.slice(0, 10);
    },
    topGuardList() {
      const rows = this.guardRankList || [];
      if (this.guardRankSort !== "days") return rows;
      return rows.slice().sort((a, b) => {
        const days = this.guardDisplayDays(b) - this.guardDisplayDays(a);
        if (days) return days;
        const rank = Number(a.rank || 9999) - Number(b.rank || 9999);
        if (rank) return rank;
        return String(a.username || a.name || a.uid || "").localeCompare(String(b.username || b.name || b.uid || ""), "zh-Hans-CN");
      });
    },
    visibleTopGuardList() {
      const rows = this.topGuardList || [];
      return this.guardRankPinned ? rows : rows.slice(0, 10);
    },
    guardDisplayTotal() {
      return Number(this.guardRankTotal || (this.topGuardList || []).length || 0);
    },
    visibleGuardList() {
      return this.sortedGuardList.slice(0, 8);
    },
    sortedGuardList() {
      return (this.guardList || []).slice().sort((a, b) => {
        const score = Number(b.shipnum || 0) - Number(a.shipnum || 0);
        if (score) return score;
        return Number(a.first_at || 0) - Number(b.first_at || 0);
      });
    },
    guardShipnum() {
      return Number((this.guardStats || {}).shipnum || 0);
    },
    guardUniqueUsers() {
      return Number((this.guardStats || {}).unique_users || 0);
    },
    guardPeriodText() {
      const stats = this.guardStats || {};
      if (stats.year && stats.month) return `${stats.year}.${String(stats.month).padStart(2, "0")} 上舰`;
      return this.guardLoading ? "上舰同步中" : "本月上舰";
    },
    guardSummaryLevelBadges() {
      return [
        { key: "governor", type: 1, title: "总督", count: this.guardLevelCount("governor") },
        { key: "admiral", type: 2, title: "提督", count: this.guardLevelCount("admiral") },
        { key: "captain", type: 3, title: "舰长", count: this.guardLevelCount("captain") },
      ];
    },
    entryStripVars() {
      return {
        "--entry-strip-rows": this.entryListRows,
      };
    },
    onlineRankTitle() {
      if (this.onlineRankLoading) return "在线榜加载中";
      if (this.onlineRankError) return this.onlineRankError;
      return this.topOnlineRank.length ? "展开当前在线榜" : "在线榜暂无数据";
    },
    guardTopTitle() {
      if (this.guardRankError) return this.guardRankError;
      return this.topGuardList.length ? "展开舰长列表" : "舰长列表暂无数据";
    },
    dayRankTitle() {
      if (this.dayRankLoading) return "日榜加载中";
      if (this.dayRankError) return this.dayRankError;
      return this.topDayRank.length ? "展开当前日榜" : "点击获取当前日榜";
    },
    readEventCount() {
      return Object.keys(this.readEventMap || {}).length;
    },
    guideHtml() {
      return this.renderMarkdown(DANMU_CONSOLE_GUIDE_MD);
    },
  },
  watch: {
    autoRefreshCloud(value) {
      this.resetCloudRefreshTimer();
      if (value) this.startCloudRefreshTimer();
    },
  },
  mounted() {
    this.loadReadEvents();
    this.reloadAll();
  },
  beforeDestroy() {
    this.setBackendFullscreen(false);
    this.disconnectWs();
    this.clearCloudRefreshTimer();
    this.clearGuardRefreshTimer();
    this.clearOnlineRankRefreshTimer();
    this.stopEntryResize();
  },
  methods: {
    userPageUrl(uid) {
      const value = String(uid || "").trim();
      return /^\d+$/.test(value) ? `https://space.bilibili.com/${value}` : "";
    },
    openUserPage(uid, event) {
      const url = this.userPageUrl(uid);
      if (!url) return;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      window.open(url, "_blank", "noopener,noreferrer");
    },
    openLiveRoom(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const url = this.normalizeUrl((this.room && this.room.url) || "") || `https://live.bilibili.com/${this.resolvedRoomId || DEFAULT_ROOM_ID}`;
      window.open(url, "_blank", "noopener,noreferrer");
    },
    toggleBackendFullscreen() {
      this.setBackendFullscreen(!this.backendFullscreen);
    },
    setBackendFullscreen(value) {
      const next = !!value;
      if (this.backendFullscreen !== next) {
        this.backendFullscreen = next;
      }
      this.$emit("fullscreen-change", next);
      this.$nextTick(() => {
        ["danmu", "sc", "gift", "entry"].forEach(panel => this.scrollPanelToLatest(panel));
      });
    },
    clearTopAlert() {
      this.error = "";
      this.wsError = "";
    },
    startRoomSession() {
      this.roomSessionId += 1;
      this.disconnectWs();
      this.clearCloudRefreshTimer();
      this.clearOnlineRankRefreshTimer();
      this.clearGuardRefreshTimer();
      this.resetRoomScopedState();
      return this.roomSessionId;
    },
    resetRoomScopedState() {
      this.cloudEvents = [];
      this.liveEvents = [];
      this.userCache = {};
      this.lastCloudAt = 0;
      this.popularity = 0;
      this.watched = 0;
      this.commandCounts = {};
      this.onlineRank = [];
      this.lastOnlineRankAt = 0;
      this.onlineRankError = "";
      this.dayRank = [];
      this.dayRankError = "";
      this.lastGuardRankAt = 0;
      this.guardRankList = [];
      this.guardRankTotal = 0;
      this.guardRankSeenToastKeys = {};
      this.guardRankError = "";
      this.resetGuardStatsState();
    },
    reloadAll() {
      const sessionId = this.startRoomSession();
      this.loading = true;
      this.error = "";
      this.wsError = "";
      this.roomAvatarFallbackStage = 0;
      post("/api/admin/danmu/live-config", { room_id: Number(this.roomInput) || DEFAULT_ROOM_ID })
        .then(res => {
          if (sessionId !== this.roomSessionId) return;
          if (!res.data || res.data.code !== 1001) {
            throw new Error((res.data && res.data.msg) || "直播配置加载失败");
          }
          const data = res.data.data || {};
          this.room = data.room || {};
          this.loadReadEvents();
          this.wsConfig = data.ws || null;
          this.cloudEventUrl = data.cloud_event_url || this.buildCloudEventUrl();
          this.bridgeUrl = data.bridge_url || this.buildBridgeUrl();
          if (data.ws_error) this.wsError = data.ws_error;
          this.fetchCloudEvents();
          this.fetchGuardStats(false);
          this.fetchGuardRank(false);
          this.fetchOnlineRank(true);
          this.startOnlineRankRefreshTimer();
          if (this.autoConnect) {
            this.connectWs();
          }
          this.resetCloudRefreshTimer();
          if (this.autoRefreshCloud) this.startCloudRefreshTimer();
        })
        .catch(err => {
          if (sessionId !== this.roomSessionId) return;
          this.error = err && err.message ? err.message : "直播配置加载失败";
          this.room = {
            room_id: Number(this.roomInput) || DEFAULT_ROOM_ID,
            uname: "天选姬_Official",
            title: "LAPLACE Event Fetcher",
          };
          this.loadReadEvents();
          this.cloudEventUrl = this.buildCloudEventUrl();
          this.bridgeUrl = this.buildBridgeUrl();
          this.fetchCloudEvents();
          this.fetchGuardStats(false);
          this.fetchGuardRank(false);
          this.fetchOnlineRank(true);
          this.startOnlineRankRefreshTimer();
          if (this.autoConnect) this.connectWs();
        })
        .finally(() => {
          if (sessionId === this.roomSessionId) this.loading = false;
        });
    },
    fetchCloudEvents() {
      if (!this.cloudEventUrl) return;
      const sessionId = this.roomSessionId;
      this.cloudLoading = true;
      axios
        .get(this.cloudEventUrl, { timeout: 25000 })
        .then(res => {
          if (sessionId !== this.roomSessionId) return;
          const payload = res.data || {};
          const data = payload.data || {};
          const rows = Array.isArray(data.data) ? data.data : (Array.isArray(payload.data) ? payload.data : []);
          const normalized = rows.map(this.normalizeCloudEvent).filter(Boolean);
          this.cloudEvents = this.capLoadedEvents(normalized);
          this.lastCloudAt = Date.now();
          this.rebuildUserCache(this.cloudEvents);
          this.$nextTick(() => {
            ["danmu", "sc", "gift", "entry"].forEach(panel => this.scrollPanelToLatest(panel));
          });
        })
        .catch(err => {
          if (sessionId !== this.roomSessionId) return;
          this.wsError = "云端事件加载失败：" + (err && err.message ? err.message : err);
        })
        .finally(() => {
          if (sessionId === this.roomSessionId) this.cloudLoading = false;
        });
    },
    buildCloudEventUrl() {
      return `/api/danmu/events?room_id=${encodeURIComponent(String(this.resolvedRoomId))}`;
    },
    capLoadedEvents(events) {
      const limits = {
        danmu: PANEL_EVENT_LIMITS.danmu,
        sc: PANEL_EVENT_LIMITS.sc,
        gift: PANEL_EVENT_LIMITS.gift,
        entry: 200,
        other: 400,
      };
      const counts = {};
      return (events || [])
        .slice()
        .sort((a, b) => Number(b.timeMs || 0) - Number(a.timeMs || 0))
        .filter(item => {
          const bucket = this.eventDisplayBucket(item);
          counts[bucket] = Number(counts[bucket] || 0) + 1;
          return counts[bucket] <= limits[bucket];
        });
    },
    eventDisplayBucket(item) {
      if (!item) return "other";
      if (item.type === "danmu") return "danmu";
      if (item.type === "sc") return "sc";
      if (this.isGiftPanelEvent(item)) return "gift";
      if (item.type === "entry") return "entry";
      return "other";
    },
    buildBridgeUrl() {
      return "";
    },
    startCloudRefreshTimer() {
      this.clearCloudRefreshTimer();
      this.cloudRefreshTimer = setInterval(() => this.fetchCloudEvents(), 30000);
    },
    clearCloudRefreshTimer() {
      if (this.cloudRefreshTimer) {
        clearInterval(this.cloudRefreshTimer);
        this.cloudRefreshTimer = null;
      }
    },
    scheduleGuardStatsRefresh() {
      this.clearGuardRefreshTimer();
      this.guardRefreshTimer = setTimeout(() => {
        this.guardRefreshTimer = null;
        this.fetchGuardStats(true);
      }, 1500);
    },
    clearGuardRefreshTimer() {
      if (this.guardRefreshTimer) {
        clearTimeout(this.guardRefreshTimer);
        this.guardRefreshTimer = null;
      }
    },
    resetGuardStatsState() {
      this.guardStats = null;
      this.guardList = [];
      this.guardError = "";
      this.guardExpanded = false;
    },
    resetCloudRefreshTimer() {
      this.clearCloudRefreshTimer();
    },
    startOnlineRankRefreshTimer() {
      this.clearOnlineRankRefreshTimer();
      this.onlineRankRefreshTimer = setInterval(() => this.fetchOnlineRank(false), 20000);
    },
    clearOnlineRankRefreshTimer() {
      if (this.onlineRankRefreshTimer) {
        clearInterval(this.onlineRankRefreshTimer);
        this.onlineRankRefreshTimer = null;
      }
    },
    updatePopularity(value, trusted) {
      const next = Number(value || 0);
      if (!Number.isFinite(next) || next <= 0) return;
      const current = Number(this.popularity || 0);
      if (!trusted && current >= 20 && next < Math.max(10, Math.floor(current * 0.35))) {
        return;
      }
      this.popularity = next;
    },
    applyOnlineRankList(list, trusted) {
      const rows = Array.isArray(list) ? list : [];
      if (!rows.length) return;
      const current = this.onlineRank || [];
      if (!trusted && current.length >= 10 && rows.length < current.length) {
        return;
      }
      this.onlineRank = rows;
    },
    toggleWs() {
      if (this.wsConnected || this.wsStatus === "connecting") {
        this.disconnectWs();
      } else {
        this.connectWs();
      }
    },
    openDayRank() {
      this.dayRankExpanded = true;
      if (!this.dayRank.length && !this.dayRankLoading) this.fetchDayRank();
    },
    openOnlineRank() {
      this.onlineRankExpanded = true;
      this.fetchOnlineRank(true);
    },
    openGuardRank() {
      this.guardTopExpanded = true;
      if (!this.guardRankList.length || Date.now() - this.lastGuardRankAt > 60000) this.fetchGuardRank(false);
    },
    closeTopRankPanel(type) {
      if (type === "guard" && !this.guardRankPinned) this.guardTopExpanded = false;
      if (type === "day" && !this.dayRankPinned) this.dayRankExpanded = false;
      if (type === "online" && !this.onlineRankPinned) this.onlineRankExpanded = false;
    },
    closePinnedTopRankPanel(type) {
      if (type === "guard") {
        this.guardRankPinned = false;
        this.guardTopExpanded = false;
      }
      if (type === "day") {
        this.dayRankPinned = false;
        this.dayRankExpanded = false;
      }
      if (type === "online") {
        this.onlineRankPinned = false;
        this.onlineRankExpanded = false;
      }
    },
    expandTopRankPanel(type) {
      if (type === "guard") {
        this.guardTopExpanded = true;
        this.guardRankPinned = true;
        if (!this.guardRankList.length || Date.now() - this.lastGuardRankAt > 60000) this.fetchGuardRank(true);
      }
      if (type === "day") {
        this.dayRankExpanded = true;
        this.dayRankPinned = true;
        if (!this.dayRank.length && !this.dayRankLoading) this.fetchDayRank();
      }
      if (type === "online") {
        this.onlineRankExpanded = true;
        this.onlineRankPinned = true;
        this.fetchOnlineRank(true);
      }
    },
    toggleTopRankPanel(type) {
      if (type === "guard") {
        this.guardTopExpanded = true;
        this.guardRankPinned = !this.guardRankPinned;
        if (!this.guardRankList.length || Date.now() - this.lastGuardRankAt > 60000) this.fetchGuardRank(true);
      }
      if (type === "day") {
        this.dayRankExpanded = true;
        this.dayRankPinned = !this.dayRankPinned;
        if (!this.dayRank.length && !this.dayRankLoading) this.fetchDayRank();
      }
      if (type === "online") {
        this.onlineRankExpanded = true;
        this.onlineRankPinned = !this.onlineRankPinned;
        this.fetchOnlineRank(true);
      }
    },
    fetchDayRank() {
      this.dayRankLoading = true;
      this.dayRankError = "";
      post("/api/admin/danmu/day-rank", {
        room_id: this.resolvedRoomId,
        ruid: this.roomAnchorUid() || DEFAULT_ANCHOR_UID,
        page: 1,
        page_size: 100,
      })
        .then(res => {
          if (!res.data || res.data.code !== 1001) {
            throw new Error((res.data && res.data.msg) || "日榜加载失败");
          }
          const data = res.data.data || {};
          const list = Array.isArray(data.list) ? data.list : [];
          this.dayRank = list.map(this.normalizeDayRankItem).filter(Boolean);
        })
        .catch(err => {
          this.dayRank = [];
          this.dayRankError = err && err.message ? err.message : "日榜加载失败";
        })
        .finally(() => {
          this.dayRankLoading = false;
        });
    },
    fetchOnlineRank(force) {
      const now = Date.now();
      if (this.onlineRankLoading) return;
      if (!force && this.lastOnlineRankAt && now - this.lastOnlineRankAt < 12000) return;
      this.onlineRankLoading = true;
      if (force) this.onlineRankError = "";
      post("/api/admin/danmu/online-rank", {
        room_id: this.resolvedRoomId,
        ruid: this.roomAnchorUid() || DEFAULT_ANCHOR_UID,
        page: 1,
        page_size: 100,
      })
        .then(res => {
          if (!res.data || res.data.code !== 1001) {
            throw new Error((res.data && res.data.msg) || "在线榜加载失败");
          }
          const data = res.data.data || {};
          const list = Array.isArray(data.list) ? data.list : [];
          this.applyOnlineRankList(this.normalizeOnlineRank(list), true);
          this.updatePopularity(data.online_count, true);
          this.lastOnlineRankAt = Date.now();
          this.onlineRankError = "";
        })
        .catch(err => {
          this.onlineRankError = err && err.message ? err.message : "在线榜加载失败";
        })
        .finally(() => {
          this.onlineRankLoading = false;
        });
    },
    fetchGuardRank(force) {
      const now = Date.now();
      if (this.guardRankLoading) return;
      if (!force && this.lastGuardRankAt && now - this.lastGuardRankAt < 60000) return;
      this.guardRankLoading = true;
      if (force) this.guardRankError = "";
      this.fetchFansDataGuardRank()
        .then(loaded => {
          if (loaded) return true;
          return post("/api/admin/danmu/guard-rank", {
            room_id: this.resolvedRoomId,
            ruid: this.roomAnchorUid() || DEFAULT_ANCHOR_UID,
            page: 1,
            page_size: 100,
          }).then(res => {
            if (!res.data || res.data.code !== 1001) {
              throw new Error((res.data && res.data.msg) || "舰长列表加载失败");
            }
            const data = res.data.data || {};
            const list = Array.isArray(data.list) ? data.list : [];
            this.guardRankList = list.map(this.normalizeGuardRankItem).filter(Boolean);
            this.guardRankTotal = Number(data.current_guard_total || data.total || this.guardRankList.length || 0);
            this.lastGuardRankAt = Date.now();
            this.guardRankError = "";
            return true;
          });
        })
        .catch(err => {
          this.guardRankError = err && err.message ? err.message : "舰长列表加载失败";
        })
        .finally(() => {
          this.guardRankLoading = false;
        });
    },
    fetchFansDataGuardRank() {
      const anchorUid = String(this.roomAnchorUid() || DEFAULT_ANCHOR_UID);
      if (anchorUid !== String(DEFAULT_ANCHOR_UID)) return Promise.resolve(false);
      const seen = {};
      const rows = [];
      const appendRows = list => {
        (list || []).forEach(item => {
          if (!item || typeof item !== "object") return;
          const key = String(item.uid || item.mid || item.rank || rows.length);
          if (seen[key]) return;
          seen[key] = true;
          rows.push(item);
        });
      };
      const requestPage = page => axios.post(TIANXUANJI_FANSDATA_API, { page }, { timeout: 12000 }).then(res => {
        const payload = res.data || {};
        if (Number(payload.code || 0) !== 0) throw new Error(payload.message || "getfansdata 获取失败");
        return payload.data || {};
      });
      return requestPage(1).then(first => {
        const info = first.info || {};
        appendRows(first.top3 || []);
        appendRows(first.list || []);
        const totalPages = Math.max(1, Math.min(10, Number(info.page || 1)));
        const requests = [];
        for (let page = 2; page <= totalPages; page += 1) {
          requests.push(requestPage(page).then(data => appendRows(data.list || [])).catch(() => null));
        }
        return Promise.all(requests).then(() => {
          const normalized = rows.map(this.normalizeGuardRankItem).filter(Boolean).sort((a, b) => Number(a.rank || 9999) - Number(b.rank || 9999));
          if (!normalized.length) return false;
          this.guardRankList = normalized;
          this.guardRankTotal = Number(info.num || normalized.length || 0);
          this.lastGuardRankAt = Date.now();
          this.guardRankError = "";
          return true;
        });
      }).catch(() => false);
    },
    readStorageKey() {
      return "tx-danmu-console-read:" + (this.resolvedRoomId || this.roomInput || DEFAULT_ROOM_ID);
    },
    localStorageAvailable() {
      return typeof window !== "undefined" && !!window.localStorage;
    },
    loadReadEvents() {
      if (!this.localStorageAvailable()) {
        this.readEventMap = {};
        return;
      }
      try {
        const raw = window.localStorage.getItem(this.readStorageKey());
        const parsed = raw ? JSON.parse(raw) : {};
        this.readEventMap = parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
      } catch (e) {
        this.readEventMap = {};
      }
    },
    saveReadEvents() {
      if (!this.localStorageAvailable()) return;
      const map = this.readEventMap || {};
      const keys = Object.keys(map);
      if (keys.length > 5000) {
        keys
          .sort((a, b) => Number(map[b] || 0) - Number(map[a] || 0))
          .slice(5000)
          .forEach(key => this.$delete(map, key));
      }
      try {
        window.localStorage.setItem(this.readStorageKey(), JSON.stringify(map));
      } catch (e) {
        // localStorage can fail in private mode or when quota is full.
      }
    },
    eventReadKey(item) {
      if (!item) return "";
      const stable = item.id || item.key;
      if (stable) return String(stable);
      return [
        this.resolvedRoomId || DEFAULT_ROOM_ID,
        item.source || "",
        item.type || "",
        item.cmd || "",
        item.timeMs || "",
        item.uid || "",
        item.message || "",
        item.giftName || "",
        item.giftAmount || "",
        item.amount || "",
      ].join("|");
    },
    isEventRead(item) {
      const key = this.eventReadKey(item);
      return !!(key && this.readEventMap && this.readEventMap[key]);
    },
    markEventRead(item) {
      const key = this.eventReadKey(item);
      if (!key) return;
      this.$set(this.readEventMap, key, Date.now());
      this.saveReadEvents();
    },
    toggleEventRead(item) {
      const key = this.eventReadKey(item);
      if (!key) return;
      if (this.isEventRead(item)) {
        this.$delete(this.readEventMap, key);
      } else {
        this.$set(this.readEventMap, key, Date.now());
      }
      this.saveReadEvents();
    },
    readableEventsForPanel(panel, filtered) {
      if (panel === "sc") return filtered === false ? this.scEvents : this.filteredSc;
      if (panel === "gift") return filtered === false ? this.giftPanelEvents : this.filteredGiftPanelEvents;
      return [];
    },
    panelReadCount(panel) {
      return this.readableEventsForPanel(panel, false).filter(item => this.isEventRead(item)).length;
    },
    markPanelRead(panel) {
      const now = Date.now();
      this.readableEventsForPanel(panel, true).forEach(item => {
        const key = this.eventReadKey(item);
        if (key) this.$set(this.readEventMap, key, now);
      });
      this.saveReadEvents();
    },
    clearPanelRead(panel) {
      this.readableEventsForPanel(panel, false).forEach(item => {
        const key = this.eventReadKey(item);
        if (key) this.$delete(this.readEventMap, key);
      });
      this.saveReadEvents();
    },
    connectWs() {
      this.disconnectWs(false);
      this.wsError = "";
      this.unsupportedCompression = false;
      const address = this.bridgeUrl || this.buildBridgeUrl();
      const sessionId = this.roomSessionId;
      this.wsStatus = "connecting";
      try {
        const ws = new WebSocket(address);
        ws.binaryType = "arraybuffer";
        this.ws = ws;
        this.lastWsConnectAt = Date.now();
        this.lastWsMessageAt = Date.now();
        ws.onopen = () => {
          if (sessionId !== this.roomSessionId || this.ws !== ws) return;
          this.wsStatus = "connected";
          this.currentAddressIndex = 0;
          this.wsError = "";
          this.lastWsMessageAt = Date.now();
          this.startHeartbeat();
        };
        ws.onmessage = event => {
          if (sessionId !== this.roomSessionId || this.ws !== ws) return;
          this.lastWsMessageAt = Date.now();
          this.handleWsMessage(event.data, sessionId);
        };
        ws.onerror = () => {
          if (sessionId !== this.roomSessionId || this.ws !== ws) return;
          this.wsError = "LEF 实时连接异常";
          this.wsStatus = "error";
        };
        ws.onclose = () => {
          if (sessionId !== this.roomSessionId || this.ws !== ws) return;
          this.clearHeartbeat();
          if (this.wsStatus !== "idle") {
            this.wsStatus = "closed";
            this.tryReconnect();
          }
        };
      } catch (err) {
        this.wsStatus = "error";
        this.wsError = err && err.message ? err.message : "LEF 实时连接失败";
        this.tryReconnect(1000);
      }
    },
    tryReconnect(delay) {
      if (this.reconnectTimer) return;
      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null;
        if (this.autoConnect) this.connectWs();
      }, Math.max(300, Number(delay || 3000)));
    },
    disconnectWs(resetStatus) {
      this.clearHeartbeat();
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      if (this.ws) {
        try {
          this.ws.onclose = null;
          this.ws.close();
        } catch (e) {
          // ignore close errors
        }
        this.ws = null;
      }
      if (resetStatus !== false) this.wsStatus = "idle";
    },
    clearHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    startHeartbeat() {
      this.clearHeartbeat();
      this.heartbeatTimer = setInterval(() => {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
          if (this.autoConnect) this.tryReconnect(800);
          return;
        }
        const silentFor = Date.now() - Number(this.lastWsMessageAt || this.lastWsConnectAt || 0);
        if (silentFor > 45000) {
          this.wsError = "LEF 实时连接静默，正在重连";
          this.wsStatus = "closed";
          try {
            this.ws.onclose = null;
            this.ws.close();
          } catch (e) {
            // ignore close errors
          }
          this.ws = null;
          if (this.autoConnect) this.tryReconnect(500);
          return;
        }
        try {
          this.ws.send(JSON.stringify({ type: "ping", timestamp: Date.now() }));
        } catch (e) {
          this.wsError = "LEF 心跳发送失败，正在重连";
          if (this.autoConnect) this.tryReconnect(500);
        }
      }, 15000);
    },
    sendAuthPacket() {
      const body = {
        uid: Number(this.wsConfig.uid || 0),
        roomid: Number(this.wsConfig.room_id || this.resolvedRoomId),
        protover: Number(this.wsConfig.protover || 0),
        platform: "web",
        type: 2,
        key: this.wsConfig.key,
      };
      if (this.wsConfig.buvid) body.buvid = this.wsConfig.buvid;
      this.sendPacket(7, JSON.stringify(body));
    },
    sendPacket(operation, body) {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
      const encoder = new TextEncoder();
      const bodyBytes = encoder.encode(body || "{}");
      const buffer = new ArrayBuffer(16 + bodyBytes.length);
      const view = new DataView(buffer);
      view.setUint32(0, buffer.byteLength);
      view.setUint16(4, 16);
      view.setUint16(6, 1);
      view.setUint32(8, operation);
      view.setUint32(12, 1);
      new Uint8Array(buffer, 16).set(bodyBytes);
      this.ws.send(buffer);
    },
    async handleWsMessage(data) {
      try {
        const sessionId = arguments.length > 1 ? arguments[1] : this.roomSessionId;
        if (sessionId !== this.roomSessionId) return;
        if (typeof data === "string") {
          this.handleLefWsPayload(JSON.parse(data), sessionId);
          return;
        }
        if (data instanceof Blob) {
          const text = await data.text();
          if (sessionId !== this.roomSessionId) return;
          this.handleLefWsPayload(JSON.parse(text), sessionId);
          return;
        }
        const buffer = data instanceof ArrayBuffer ? data : await data.arrayBuffer();
        if (sessionId !== this.roomSessionId) return;
        const packets = await this.parsePackets(buffer);
        packets.forEach(packet => this.handlePacket(packet, sessionId));
      } catch (err) {
        this.wsError = err && err.message ? err.message : "实时消息解析失败";
      }
    },
    handleLefWsPayload(payload, sessionId) {
      if (sessionId !== this.roomSessionId) return;
      const envelopeType = String(payload.type || "");
      if (envelopeType === "established") {
        this.wsStatus = "connected";
        this.wsError = "";
        return;
      }
      if (envelopeType === "ping") {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify({ type: "pong", timestamp: Date.now() }));
        }
        return;
      }
      const event = payload.event || payload.data || payload;
      if (!event || !event.type || event.status) return;
      const normalized = this.normalizeCloudEvent(event, "live");
      if (normalized) this.pushLiveEvent(normalized);
    },
    async parsePackets(buffer) {
      const packets = [];
      const view = new DataView(buffer);
      let offset = 0;
      while (offset + 16 <= buffer.byteLength) {
        const packetLength = view.getUint32(offset);
        const headerLength = view.getUint16(offset + 4);
        const version = view.getUint16(offset + 6);
        const operation = view.getUint32(offset + 8);
        if (!packetLength || offset + packetLength > buffer.byteLength) break;
        const body = buffer.slice(offset + headerLength, offset + packetLength);
        if (operation === 5 && version === 2) {
          const inflated = await this.inflateDeflate(body);
          const nested = await this.parsePackets(inflated);
          packets.push.apply(packets, nested);
        } else if (operation === 5 && version === 3) {
          this.unsupportedCompression = true;
          this.wsError = "浏览器暂不支持 B站 brotli 实时包，已使用 protover=0 尽量避免";
        } else {
          packets.push({ operation, version, body });
        }
        offset += packetLength;
      }
      return packets;
    },
    async inflateDeflate(buffer) {
      try {
        const inflated = pako.inflate(new Uint8Array(buffer));
        return inflated.buffer.slice(inflated.byteOffset, inflated.byteOffset + inflated.byteLength);
      } catch (pakoError) {
        // fall through to the browser stream decoder below
      }
      if (typeof DecompressionStream === "undefined") {
        throw new Error("当前浏览器不支持 DecompressionStream，无法解压 B站实时包");
      }
      const formats = ["deflate", "deflate-raw"];
      let lastError = null;
      for (let i = 0; i < formats.length; i += 1) {
        try {
          const stream = new Blob([buffer]).stream().pipeThrough(new DecompressionStream(formats[i]));
          return await new Response(stream).arrayBuffer();
        } catch (err) {
          lastError = err;
        }
      }
      throw lastError || new Error("B站实时包解压失败");
    },
    handlePacket(packet, sessionId) {
      if (sessionId !== this.roomSessionId) return;
      if (packet.operation === 8) {
        const auth = this.decodeJson(packet.body);
        if (!auth || auth.code !== 0) {
          this.wsError = "B站实时鉴权失败";
          this.wsStatus = "error";
        }
        return;
      }
      if (packet.operation === 3) {
        const view = new DataView(packet.body);
        this.updatePopularity(packet.body.byteLength >= 4 ? view.getUint32(0) : 0, false);
        return;
      }
      if (packet.operation !== 5) return;
      const payload = this.decodeJson(packet.body);
      if (!payload) return;
      this.handleBilibiliCommand(payload, sessionId);
    },
    decodeJson(buffer) {
      try {
        const text = new TextDecoder("utf-8").decode(buffer);
        if (!text) return null;
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    },
    handleBilibiliCommand(payload, sessionId) {
      if (sessionId !== this.roomSessionId) return;
      const cmd = String(payload.cmd || "").split(":")[0];
      this.commandCounts[cmd] = (this.commandCounts[cmd] || 0) + 1;
      if (cmd === "WATCHED_CHANGE") {
        const data = payload.data || {};
        this.watched = Number(data.num || data.text_large || 0) || this.watched;
        return;
      }
      if (cmd === "ONLINE_RANK_COUNT") {
        this.updatePopularity((payload.data || {}).count, false);
        return;
      }
      if (cmd === "ONLINE_RANK_V2" || cmd === "ONLINE_RANK_TOP3" || cmd === "ONLINE_RANK_LIST") {
        const data = payload.data || {};
        const list = data.list || data.rank_list || data.online_rank_list || [];
        const rankList = this.normalizeOnlineRank(list);
        this.applyOnlineRankList(rankList, false);
        return;
      }
      const event = this.normalizeLiveCommand(cmd, payload);
      if (event) this.pushLiveEvent(event);
    },
    pushLiveEvent(event) {
      this.rememberUser(event);
      if (event.type === "stat" && event.watched) {
        this.watched = event.watched;
      }
      if (event.type === "rank" && event.rankList && event.rankList.length) {
        this.applyOnlineRankList(event.rankList, false);
      }
      if (event.type === "toast") {
        this.bumpGuardRankTotalFromToast(event);
        this.scheduleGuardStatsRefresh();
      }
      this.liveEvents.unshift(event);
      if (this.liveEvents.length > MAX_LIVE_EVENTS) {
        this.liveEvents.splice(MAX_LIVE_EVENTS);
      }
      this.scrollPanelsForEvent(event);
    },
    bumpGuardRankTotalFromToast(event) {
      if (!event || !this.isOpeningGuardToast(event)) return;
      const key = event.key || [event.uid, event.toastType || event.guardType, event.timeMs || "", event.toastAmount || 1].join("-");
      if (this.guardRankSeenToastKeys[key]) return;
      this.$set(this.guardRankSeenToastKeys, key, true);
      const current = Number(this.guardRankTotal || (this.topGuardList || []).length || 0);
      if (current > 0) this.guardRankTotal = current + 1;
    },
    isOpeningGuardToast(event) {
      const text = String((event && (event.message || event.giftName || event.toastName || event.guardName)) || "");
      if (/续费|延长|renew/i.test(text)) return false;
      if (/开通|成为|上舰|加入/.test(text)) return true;
      return Number((event && event.toastAmount) || 1) <= 1;
    },
    normalizeLiveCommand(cmd, payload) {
      const now = Date.now();
      if (cmd === "DANMU_MSG") {
        const info = payload.info || [];
        const meta = info[0] || [];
        const user = info[2] || [];
        const medal = info[3] || [];
        const uid = String(user[0] || "");
        const emoteMap = meta[13] && typeof meta[13] === "object" ? meta[13] : {};
        return {
          key: "live-danmu-" + now + "-" + uid + "-" + Math.random(),
          source: "live",
          type: "danmu",
          cmd,
          uid,
          username: user[1] || "",
          avatar: this.cachedAvatar(uid),
          nameColor: user[7] || "",
          message: info[1] || "",
          medal: { level: medal[0] || 0, name: medal[1] || "", guardType: medal[10] || 0 },
          userLevel: (info[4] || [])[0] || 0,
          userLvl: (info[4] || [])[0] || 0,
          userLvlBorder: (info[4] || [])[2] || "",
          currentRank: (info[4] || [])[4] || 0,
          emote: meta[13] && meta[13].url ? meta[13] : null,
          bmotes: emoteMap,
          emotes: Object.keys(emoteMap).map(key => this.normalizeUrl((emoteMap[key] || {}).url)).filter(Boolean),
          timeMs: now,
          raw: payload,
        };
      }
      if (cmd === "SUPER_CHAT_MESSAGE") {
        const data = payload.data || {};
        const userInfo = data.user_info || {};
        return {
          key: "live-sc-" + (data.id || now),
          source: "live",
          type: "sc",
          cmd,
          uid: String(data.uid || userInfo.uid || ""),
          username: userInfo.uname || data.uname || "",
          avatar: this.normalizeUrl(userInfo.face || data.face || ""),
          message: data.message || "",
          amount: Number(data.price || 0),
          price: Number(data.price || 0),
          priceNormalized: Number(data.price || 0),
          medal: data.medal_info || {},
          timeMs: Number(data.ts || 0) ? Number(data.ts) * 1000 : now,
          color: data.message_color || "",
          backgroundColor: data.background_bottom_color || data.background_color || data.background_price_color || "",
          guardBackground: this.normalizeUrl(data.background_bottom_color || ""),
          messageTrans: data.message_trans || "",
          raw: payload,
        };
      }
      if (cmd === "SEND_GIFT" || cmd === "COMBO_SEND") {
        const data = payload.data || {};
        const giftInfo = data.gift_info || {};
        return {
          key: "live-gift-" + (data.rnd || data.combo_id || now) + "-" + Math.random(),
          source: "live",
          type: "gift",
          cmd,
          uid: String(data.uid || ""),
          username: data.uname || "",
          avatar: this.normalizeUrl(data.face || ""),
          message: data.action || data.giftName || data.gift_name || "投喂",
          giftName: data.giftName || data.gift_name || data.gift_name_text || "",
          giftId: data.giftId || data.gift_id || 0,
          giftIcon: this.normalizeUrl(data.gift_icon || giftInfo.img_basic || giftInfo.webp || ""),
          giftAmount: Number(data.num || data.gift_num || data.combo_num || 1),
          amount: this.normalizePrice(data.price || data.discount_price || 0, data.num || data.gift_num || 1),
          price: Number(data.price || data.discount_price || 0),
          coinType: data.coin_type || data.coinType || "gold",
          medal: data.medal_info || {},
          timeMs: Number(data.timestamp || 0) ? Number(data.timestamp) * 1000 : now,
          raw: payload,
        };
      }
      if (cmd === "USER_TOAST_MSG" || cmd === "GUARD_BUY") {
        const data = payload.data || {};
        return {
          key: "live-toast-" + now + "-" + (data.uid || ""),
          source: "live",
          type: "toast",
          cmd,
          uid: String(data.uid || ""),
          username: data.username || data.uname || "",
          avatar: this.normalizeUrl(data.face || ""),
          message: data.toast_msg || data.message || "舰长续费",
          giftName: data.role_name || data.gift_name || "舰长",
          toastName: data.role_name || data.gift_name || "舰长",
          toastType: data.guard_level || data.privilege_type || data.role_id || 3,
          giftAmount: Number(data.num || 1),
          toastAmount: Number(data.num || 1),
          toastAmountUnit: data.unit || "月",
          amount: this.normalizePrice(data.price || 0, 1),
          price: Number(data.price || 0),
          priceNormalized: this.normalizePrice(data.price || 0, 1),
          medal: data.medal_info || {},
          timeMs: now,
          raw: payload,
        };
      }
      if (cmd === "INTERACT_WORD" || cmd === "ENTRY_EFFECT" || cmd === "WELCOME" || cmd === "WELCOME_GUARD") {
        const data = payload.data || {};
        const message = this.entryMessage(cmd, data);
        const entryBackground = this.extractEntryBackground(data);
        return {
          key: "live-entry-" + now + "-" + (data.uid || "") + "-" + Math.random(),
          source: "live",
          type: "entry",
          cmd,
          uid: String(data.uid || ""),
          username: data.uname || data.copy_writing || "",
          avatar: this.normalizeUrl(data.face || ""),
          message,
          msgType: data.msg_type || "",
          action: data.msg_type || data.action || "",
          relation: data.relation || data.relation_type || "",
          medal: data.fans_medal || data.medal_info || {},
          background: this.normalizeUrl(entryBackground.static || data.background || data.web_basemap_url || data.basemap_url || ""),
          backgroundAnimated: this.normalizeUrl(entryBackground.dynamic || data.mobile_dynamic_url || data.background || data.web_basemap_url || data.basemap_url || ""),
          textColor: data.copy_color || data.text_color || "",
          nameColor: data.name_color || "",
          business: data.business || "",
          effectId: data.id || data.effect_id || "",
          showAvatar: data.show_avatar !== false,
          showWealthMedal: data.show_wealth_medal !== false,
          timeMs: Number(data.timestamp || 0) ? Number(data.timestamp) * 1000 : now,
          raw: payload,
        };
      }
      return null;
    },
    normalizeCloudEvent(item, source) {
      const type = item.type || "";
      const timeMs = this.timestampMs(item);
      const uinfo = item.uinfo || {};
      const baseInfo = uinfo.base || {};
      const wealth = uinfo.wealth || {};
      const medalInfo = uinfo.medal || {};
      const guardInfo = uinfo.guard || {};
      const medal = item.medal || {
        name: medalInfo.name || "",
        level: medalInfo.level || 0,
        guardType: (medalInfo.guard || {}).level || (medalInfo.guard_level) || 0,
      };
      const guardType = Number(item.guardType || medal.guardType || medal.guard_level || guardInfo.level || 0);
      const base = {
        key: item.id || ((source || "cloud") + "-" + type + "-" + timeMs + "-" + item.uid),
        id: item.id || "",
        source: source || "cloud",
        cmd: type,
        origin: item.origin || this.resolvedRoomId,
        originIdx: Number(item.originIdx || 0),
        uid: String(item.uid || ""),
        username: item.username || baseInfo.name || "",
        avatar: this.normalizeUrl(item.avatar || baseInfo.face || ""),
        avatarFrame: this.normalizeUrl(item.avatarFrame || item.uheadFrame || (uinfo.uhead_frame || {}).url || ""),
        nameColor: item.nameColor || baseInfo.name_color_str || "",
        message: this.cleanEventMessage(item.message || item.messageRaw || ""),
        msgType: item.msgType || item.msg_type || item.msg_type_v2 || "",
        medal,
        guardType,
        guardName: this.guardName(guardType),
        wealthMedalLevel: item.wealthMedalLevel || wealth.level || 0,
        userLevel: item.userLvl || item.userLevel || 0,
        userLvl: item.userLvl || item.userLevel || 0,
        userLvlBorder: item.userLvlBorder || "",
        userType: item.userType || 0,
        currentRank: item.currentRank || 0,
        guardLeader: !!item.guardLeader || !!((uinfo.guard_leader || {}).is_guard_leader),
        sendType: item.sendType || 0,
        phoneVerified: item.phoneVerified || 0,
        reply: item.reply || {},
        sign: item.sign || "",
        emote: item.emote || null,
        bmotes: item.bmotes || null,
        timeMs,
        raw: item,
      };
      if (type === "message") {
        base.type = "danmu";
        base.emotes = this.extractEmotes(item);
        return base;
      }
      if (type === "effect-message") {
        base.type = "entry";
        base.actionLabel = "特效";
        base.message = this.cleanEventMessage(item.messageRaw || item.message || "特效消息");
        return base;
      }
      if (type === "superchat") {
        base.type = "sc";
        base.amount = Number(item.priceNormalized || item.price || 0);
        base.price = Number(item.price || item.priceNormalized || 0);
        base.priceNormalized = Number(item.priceNormalized || item.price || 0);
        base.color = item.messageColor || "";
        base.messageColor = item.messageColor || "";
        base.messageTrans = item.messageTrans || "";
        base.transMark = item.transMark || 0;
        base.deleted = !!item.deleted;
        base.duration = Number(item.duration || 0);
        base.backgroundColor = item.backgroundColor || "";
        base.guardBackground = this.isUrl(item.guardBackground) ? this.normalizeUrl(item.guardBackground) : "";
        base.avatarFrame = this.normalizeUrl(item.avatarFrame || base.avatarFrame);
        base.scId = item.scId || item.id || "";
        return base;
      }
      if (type === "gift") {
        base.type = "gift";
        base.giftName = item.giftName || item.message || "";
        base.giftAction = item.giftAction || "";
        base.giftId = item.giftId || 0;
        base.giftIcon = this.normalizeUrl(item.giftIcon || "");
        base.giftAmount = Number(item.giftAmount || 1);
        base.giftType = item.giftType || 0;
        base.giftRemain = Number(item.giftRemain || 0);
        base.coinType = item.coinType || "gold";
        base.receiver = item.receiver || null;
        base.blindGift = item.blindGift || null;
        base.price = Number(item.price || 0);
        base.priceNormalized = Number(item.priceNormalized || 0);
        base.amount = Number(item.priceNormalized || 0);
        if (item.blindGift && item.blindGift.original_gift_name) {
          base.blindGiftName = item.blindGift.original_gift_name;
        }
        return base;
      }
      if (type === "toast") {
        base.type = "toast";
        base.giftName = item.toastName || "舰长";
        base.giftAmount = Number(item.toastAmount || 1);
        base.amount = Number(item.priceNormalized || 0);
        base.price = Number(item.price || 0);
        base.priceNormalized = Number(item.priceNormalized || 0);
        base.guardType = item.toastType || item.guardType || 3;
        base.toastType = item.toastType || item.guardType || 3;
        base.toastName = item.toastName || this.guardName(base.guardType) || "舰长";
        base.toastAmount = Number(item.toastAmount || 1);
        base.toastAmountUnit = item.toastAmountUnit || "月";
        base.guardName = item.toastName || this.guardName(base.guardType);
        base.toastTotalCount = Number(item.toastTotalCount || 0);
        base.toastColor = item.color || "";
        base.color = item.color || "";
        base.mockPrice = !!item.mockPrice;
        base.effectId = item.effectId || 0;
        base.avatar = this.normalizeUrl(item.avatar || this.cachedAvatar(item.uid));
        base.message = this.cleanEventMessage(item.message || `${base.username} ${base.giftName}`);
        return base;
      }
      if (type === "entry-effect") {
        base.type = "entry";
        base.actionLabel = "进场";
        base.background = this.normalizeUrl(item.background || item.webBasemapUrl || item.basemapUrl || "");
        base.backgroundAnimated = this.normalizeUrl(item.backgroundAnimated || item.mobileDynamicUrl || item.dynamicUrl || item.background || "");
        base.textColor = item.textColor || "";
        base.nameColor = item.nameColor || base.nameColor || "";
        base.showAvatar = item.showAvatar !== false;
        base.showWealthMedal = item.showWealthMedal !== false;
        base.business = item.business || "";
        base.effectId = item.effectId || "";
        base.message = this.cleanEventMessage(item.message || "高能进场");
        return base;
      }
      if (type === "interaction") {
        base.type = "entry";
        base.action = item.action || "";
        base.relation = item.relation || null;
        base.actionLabel = this.interactionActionText(item.action, item.relation, item.message, item.msgType || item.msg_type);
        base.message = base.actionLabel || "进入直播间";
        base.background = this.normalizeUrl(item.background || item.webBasemapUrl || item.basemapUrl || "");
        base.backgroundAnimated = this.normalizeUrl(item.backgroundAnimated || item.mobileDynamicUrl || item.dynamicUrl || base.background || "");
        return base;
      }
      if (type === "watched-update") {
        base.type = "stat";
        base.watched = Number(item.watched || 0);
        base.message = item.message || "看过人数更新";
        return base;
      }
      if (type === "online-rank-update") {
        base.type = "rank";
        base.rankList = this.normalizeOnlineRank(item.list || []);
        base.message = item.message || "在线榜更新";
        return base.rankList.length ? base : null;
      }
      if (type.indexOf("lottery") >= 0) {
        base.type = "lottery";
        base.giftName = item.rewardName || (type === "lottery-start" ? "天选时刻开始" : "天选时刻中奖名单");
        base.giftIcon = this.normalizeUrl(item.rewardImage || "");
        base.giftAmount = Number(item.rewardNum || 1);
        base.amount = Number(item.priceNormalized || item.giftPriceNormalized || 0);
        base.message = item.message || item.messageToJoin || base.giftName;
        base.rewardList = this.normalizeRewardList(item);
        base.winners = this.normalizeLotteryWinners(item.list || []);
        return base;
      }
      if (type.indexOf("red-envelope") >= 0) {
        base.type = "red-envelope";
        base.giftName = item.rewardName || item.message || "红包";
        base.giftIcon = this.normalizeUrl(item.rewardImage || item.icon || this.firstRewardImage(item));
        base.giftAmount = Number(item.rewardNum || 1);
        base.amount = Number(item.priceNormalized || item.priceForUsers || 0);
        base.rewardList = this.normalizeRewardList(item);
        base.winners = this.normalizeLotteryWinners(item.list || []);
        return base;
      }
      return null;
    },
    normalizeLotteryWinners(list) {
      return (list || []).map(item => {
        if (Array.isArray(item)) {
          return {
            uid: String(item[0] || ""),
            name: item[1] || "",
            avatar: this.normalizeUrl(item[2] || ""),
          };
        }
        const base = ((item.uinfo || {}).base || {});
        return {
          uid: String(item.uid || ""),
          name: item.uname || item.username || item.name || item.user_name || base.name || "",
          avatar: this.normalizeUrl(item.face || item.avatar || item.user_face || base.face || ""),
        };
      }).filter(item => item.uid || item.name || item.avatar).slice(0, 8);
    },
    normalizeRewardList(item) {
      if (Array.isArray(item.list) && item.type === "red-envelope-start") {
        return item.list.map(gift => ({
          id: gift.gift_id || gift.id || gift.gift_name,
          name: gift.gift_name || gift.name || "礼物",
          num: Number(gift.num || 1),
          icon: this.normalizeUrl(gift.gift_pic || gift.icon || ""),
        })).filter(gift => gift.name || gift.icon).slice(0, 5);
      }
      const rewards = item.rewards || {};
      const rewardList = Object.keys(rewards).map(key => {
        const reward = rewards[key] || {};
        return {
          id: key,
          name: reward.award_name || reward.name || "奖品",
          num: Number(reward.num || 1),
          icon: this.normalizeUrl(reward.award_pic || reward.award_big_pic || ""),
        };
      }).filter(gift => gift.name || gift.icon);
      if (rewardList.length) return rewardList.slice(0, 5);
      if (item.rewardName || item.rewardImage) {
        return [{
          id: item.rewardName || item.rewardImage,
          name: item.rewardName || "奖品",
          num: Number(item.rewardNum || 1),
          icon: this.normalizeUrl(item.rewardImage || ""),
        }];
      }
      return [];
    },
    normalizeOnlineRank(list) {
      return (list || []).map((item, index) => {
        const base = ((item.uinfo || {}).base || {});
        const raw = item.raw || item;
        const score = item.score_info || raw.score_info || {};
        const rankInfo = item.rank_info || raw.rank_info || {};
        const rankScore = this.rankNumericValue(
          item.rank_score,
          item.rankScore,
          raw.rank_score,
          raw.rankScore,
          score.rank_score,
          score.value,
          rankInfo.rank_score,
          rankInfo.value
        );
        return {
          uid: String(item.uid || item.mid || base.uid || ""),
          name: item.uname || item.username || item.name || base.name || "未知用户",
          avatar: this.normalizeUrl(item.face || item.avatar || base.face || ""),
          value: Number.isFinite(rankScore) ? rankScore : 0,
          rank_score: Number.isFinite(rankScore) ? rankScore : 0,
          medal: item.medal || item.medal_info || item.fans_medal || {},
          raw,
        };
      }).filter(item => item.uid || item.name || item.avatar);
    },
    normalizeGuardRankItem(item, index) {
      if (!item) return null;
      const base = (((item.uinfo || {}).base) || {});
      const raw = item.raw || item;
      const uid = item.uid || item.mid || base.uid || "";
      const medal = item.medal || item.medal_info || item.fans_medal || raw.medal_info || raw.fans_medal || {};
      const name = item.username || item.uname || item.name || base.name || "";
      const avatar = this.normalizeUrl(item.avatar || item.face || base.face || "");
      const companionDays = Number(item.companion_days || item.total_days || item.accompany_days || item.accompany || item.days || raw.accompany || raw.companion_days || raw.days || 0);
      if (!uid && !name && !avatar) return null;
      return {
        uid: String(uid || ""),
        username: name || String(uid || ""),
        name: name || String(uid || ""),
        avatar,
        rank: Number(item.rank || index + 1),
        guard_level: Number(item.guard_level || item.guardLevel || item.guardType || medal.guard_level || medal.guardLevel || 0),
        guard_level_name: item.guard_level_name || item.guardLevelName || "",
        perkLevel: Number(item.perkLevel || item.perk_level || item.guard_sub_level || raw.guard_sub_level || 1),
        medal,
        companion_days: companionDays,
        companionDaysText: companionDays,
        raw,
      };
    },
    normalizeDayRankItem(item, index) {
      if (!item) return null;
      const raw = item.raw || item;
      const base = (((item.uinfo || {}).base) || ((item.user || {}).base) || {});
      const user = item.user || item.user_info || item.uinfo || {};
      const rawUser = raw.user || raw.user_info || raw.uinfo || {};
      const rawScore = raw.score_info || {};
      const rawRank = raw.rank_info || {};
      const rawMedal = raw.medal || raw.medal_info || raw.fans_medal || rawUser.medal || {};
      const uid = item.uid || item.mid || user.uid || user.mid || base.uid || "";
      const name = item.name || item.uname || item.username || user.name || user.uname || user.username || base.name || "";
      const avatar = this.normalizeUrl(item.avatar || item.face || user.avatar || user.face || base.face || "");
      const medalScore = this.rankNumericValue(
        item.medal_score,
        item.medalScore,
        raw.medal_score,
        raw.medalScore,
        rawMedal.score,
        rawMedal.value
      );
      const rankScore = this.rankNumericValue(
        item.rank_score,
        item.rankScore,
        item.value,
        item.score,
        raw.rank_score,
        raw.rankScore,
        raw.value,
        raw.score
      );
      const fallbackValue = this.rankNumericValue(
        item.score,
        item.rank_score,
        item.room_score,
        item.contribution,
        item.coin,
        item.amount,
        raw.value,
        raw.score,
        raw.rank_score,
        raw.room_score,
        raw.contribution,
        raw.coin,
        raw.amount,
        raw.score_text,
        raw.scoreText,
        rawScore.rank_score,
        rawScore.room_score,
        rawScore.contribution,
        rawScore.score,
        rawScore.value,
        rawRank.rank_score,
        rawRank.room_score,
        rawRank.contribution,
        rawRank.score,
        rawRank.value
      );
      const value = Number.isFinite(medalScore) && medalScore > 0 ? medalScore : 0;
      if (!uid && !name && !avatar) return null;
      return {
        uid: String(uid || ""),
        name: name || String(uid || ""),
        username: name || String(uid || ""),
        avatar,
        value,
        value_available: value > 0,
        medal_score: Number.isFinite(medalScore) ? medalScore : 0,
        rank_score: Number.isFinite(rankScore) && rankScore > 0 ? rankScore : fallbackValue,
        rank: Number(item.rank || item.rank_no || item.order || index + 1),
        raw,
      };
    },
    rankNumericValue(...values) {
      const parsed = values
        .map(value => this.parseRankNumber(value))
        .filter(value => Number.isFinite(value));
      const positive = parsed.find(value => value > 0);
      return positive == null ? (parsed[0] || 0) : positive;
    },
    parseRankNumber(value) {
      if (value == null || value === "") return NaN;
      if (typeof value === "number") return value;
      const text = String(value).trim().replace(/,/g, "");
      if (!text) return NaN;
      const match = text.match(/(\d+(?:\.\d+)?)/);
      if (!match) return NaN;
      const multiplier = text.indexOf("亿") >= 0 ? 100000000 : (text.indexOf("万") >= 0 ? 10000 : 1);
      return Number(match[1]) * multiplier;
    },
    rankUserTitle(item, index) {
      return [
        "#" + (index + 1),
        item && (item.name || item.username),
        item && item.uid ? "UID " + item.uid : "",
        item && item.value_available && item.value ? this.formatNumber(item.value) : "",
      ].filter(Boolean).join(" / ");
    },
    dayRankValueText(item) {
      if (!item || !item.value_available) return "-";
      return this.formatNumber(item.value || 0);
    },
    firstRewardImage(item) {
      const list = item.list || [];
      for (let i = 0; i < list.length; i += 1) {
        const gift = list[i];
        if (gift && typeof gift === "object" && gift.gift_pic) return gift.gift_pic;
      }
      const rewards = item.rewards || {};
      const firstKey = Object.keys(rewards)[0];
      if (firstKey && rewards[firstKey]) return rewards[firstKey].award_pic || rewards[firstKey].award_big_pic || "";
      return "";
    },
    extractEmotes(item) {
      const urls = [];
      if (item.emote && item.emote.url) urls.push(item.emote.url);
      if (item.bmotes && typeof item.bmotes === "object") {
        Object.keys(item.bmotes).forEach(key => {
          const value = item.bmotes[key];
          if (typeof value === "string") urls.push(value);
          else if (value && typeof value === "object") urls.push(value.url || value.gif_url || value.web_url || "");
        });
      }
      return urls.map(this.normalizeUrl).filter(Boolean);
    },
    panelOrderTitle(panel) {
      return (this.panelOrders && this.panelOrders[panel]) === "asc" ? "新在下" : "新在上";
    },
    panelOrderIcon(panel) {
      return (this.panelOrders && this.panelOrders[panel]) === "asc" ? "el-icon-bottom" : "el-icon-top";
    },
    togglePanelOrder(panel) {
      const current = (this.panelOrders && this.panelOrders[panel]) || "desc";
      this.$set(this.panelOrders, panel, current === "desc" ? "asc" : "desc");
      this.$nextTick(() => this.scrollPanelToLatest(panel));
    },
    orderedEvents(events, panel) {
      const dir = (this.panelOrders && this.panelOrders[panel]) || "desc";
      return (events || []).slice().sort((a, b) => {
        const diff = (Number(a.timeMs || 0) - Number(b.timeMs || 0));
        return dir === "asc" ? diff : -diff;
      });
    },
    latestPanelEvents(events, panel, limit) {
      const newest = (events || [])
        .slice()
        .sort((a, b) => Number(b.timeMs || 0) - Number(a.timeMs || 0))
        .slice(0, limit);
      return this.orderedEvents(newest, panel);
    },
    filterGiftType(events) {
      if (this.giftTypeFilter === "guard") return (events || []).filter(item => item.type === "toast");
      if (this.giftTypeFilter === "gift") return (events || []).filter(item => item.type !== "toast");
      return events || [];
    },
    isGiftPanelEvent(item) {
      if (!item) return false;
      if (item.type === "gift" || item.type === "toast") return this.eventAmount(item) > 0;
      if (item.type === "lottery") return true;
      if (item.type === "red-envelope") return this.eventAmount(item) > 0 || (item.rewardList && item.rewardList.length) || (item.winners && item.winners.length);
      return false;
    },
      isEntryRoomListEvent(item) {
        if (!item || item.type !== "entry") return false;
        const cmd = String(item.cmd || "").toUpperCase();
        if (cmd === "ENTRY_EFFECT" || cmd === "EFFECT-MESSAGE") return false;
        if (item.actionLabel === "特效") return false;
        return this.isBlackEntryNameEvent(item);
      },
      dedupeEntryRoomEvents(events) {
        const result = [];
        const lastByUser = {};
        (events || []).forEach(item => {
          const userKey = String(item.uid || item.username || "").trim();
          const timeMs = Number(item.timeMs || 0);
          if (userKey) {
            const last = lastByUser[userKey];
            if (last && Math.abs(timeMs - Number(last.timeMs || 0)) <= 5000) return;
            lastByUser[userKey] = item;
          }
          result.push(item);
        });
        return result;
      },
      isBlackEntryNameEvent(item) {
        const color = this.entryNameColor(item);
        if (!color) return true;
        return this.isBlackLikeColor(color);
      },
      entryNameColor(item) {
        const raw = (item && item.raw) || {};
        const liveData = raw.data || {};
        const rawBase = ((raw.uinfo || {}).base) || {};
        return item && (
          item.nameColor ||
          item.name_color ||
          item.name_color_str ||
          liveData.name_color ||
          liveData.nameColor ||
          raw.nameColor ||
          raw.name_color ||
          raw.name_color_str ||
          rawBase.name_color_str ||
          ""
        );
      },
      isBlackLikeColor(value) {
        const parsed = this.parseEntryColor(value);
        if (!parsed) return false;
        return parsed.alpha > 0.5 && parsed.red <= 90 && parsed.green <= 90 && parsed.blue <= 90;
      },
      parseEntryColor(value) {
        const color = String(value || "").trim().toLowerCase();
        if (!color) return null;
        const named = {
          black: "#000000",
          white: "#ffffff",
          yellow: "#ffff00",
          gold: "#ffd700",
        };
        const normalized = named[color] || color;
        const hex = normalized.match(/^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i);
        if (hex) {
          let hexValue = hex[1];
          if (hexValue.length === 3 || hexValue.length === 4) {
            hexValue = hexValue.split("").map(char => char + char).join("");
          }
          const rgb = hexValue.slice(0, 6);
          return {
            red: parseInt(rgb.slice(0, 2), 16),
            green: parseInt(rgb.slice(2, 4), 16),
            blue: parseInt(rgb.slice(4, 6), 16),
            alpha: hexValue.length >= 8 ? parseInt(hexValue.slice(6, 8), 16) / 255 : 1,
          };
        }
        const rgb = normalized.replace(/\s+/g, "").match(/^rgba?\((\d+),(\d+),(\d+)(?:,([0-9.]+))?\)$/);
        if (!rgb) return null;
        return {
          red: Number(rgb[1]),
          green: Number(rgb[2]),
          blue: Number(rgb[3]),
          alpha: rgb[4] == null ? 1 : Number(rgb[4]),
        };
      },
    roomAvatarProxy() {
      return this.roomAvatarCandidates().find(url => url && url.indexOf("/bilibili/avatar/") >= 0) || "";
    },
    roomAnchorUid() {
      const room = this.room || {};
      const uid = room.uid || room.mid || room.owner_uid || room.anchor_uid || room.anchorUid || room.up_uid || room.upUid || "";
      if (uid) return uid;
      if (Number(this.resolvedRoomId) === DEFAULT_ROOM_ID || String(room.uname || "").indexOf("天选姬") >= 0) {
        return DEFAULT_ANCHOR_UID;
      }
      return "";
    },
    roomAvatarCandidates() {
      const candidates = [];
      const direct = this.normalizeUrl(this.room.face || this.room.avatar || "");
      if (direct) candidates.push(direct);
      const uid = this.roomAnchorUid();
      if (uid) candidates.push(`${LAPLACE_WORKERS}/bilibili/avatar/${encodeURIComponent(uid)}?size=320`);
      candidates.push(NO_FACE);
      return candidates.filter(Boolean).filter((url, index, list) => list.indexOf(url) === index);
    },
    useRoomAvatarFallback(event) {
      const candidates = this.roomAvatarCandidates();
      const nextStage = Math.min(this.roomAvatarFallbackStage + 1, candidates.length - 1);
      this.roomAvatarFallbackStage = nextStage;
      if (!event || !event.target) return;
      event.target.src = candidates[nextStage] || NO_FACE;
    },
    scrollPanelsForEvent(event) {
      if (!event) return;
      const targets = [];
      if (event.type === "danmu") targets.push("danmu");
      if (event.type === "sc") targets.push("sc");
      if (this.isGiftPanelEvent(event)) targets.push("gift");
      if (event.type === "entry") targets.push("entry");
      if (!targets.length) return;
      this.$nextTick(() => targets.forEach(panel => this.scrollPanelToLatest(panel)));
    },
    scrollPanelToLatest(panel) {
      const refs = {
        danmu: "danmuList",
        sc: "scList",
        gift: "giftList",
        entry: "entryList",
      };
      const el = this.refElement(refs[panel]);
      if (!el) return;
      const orderPanel = panel === "entry" ? "danmu" : panel;
      const order = (this.panelOrders && this.panelOrders[orderPanel]) || "desc";
      if (order === "asc") el.scrollTop = el.scrollHeight;
      else el.scrollTop = 0;
    },
    refElement(ref) {
      const target = typeof ref === "string" ? this.$refs[ref] : ref;
      return target && target.$el ? target.$el : target;
    },
    startEntryResize(event) {
      if (!event) return;
      event.preventDefault();
      const lineHeight = this.entryListRowHeight();
      this.entryResizeState = {
        startY: event.clientY,
        startRows: Number(this.entryListRows || 4),
        lineHeight,
      };
      document.addEventListener("mousemove", this.onEntryResize);
      document.addEventListener("mouseup", this.stopEntryResize);
    },
    onEntryResize(event) {
      if (!this.entryResizeState || !event) return;
      const state = this.entryResizeState;
      const deltaRows = Math.round((state.startY - event.clientY) / state.lineHeight);
      const rows = Math.max(1, Math.min(4, state.startRows + deltaRows));
      if (rows !== this.entryListRows) {
        this.entryListRows = rows;
        this.$nextTick(() => this.scrollPanelToLatest("entry"));
      }
    },
    stopEntryResize() {
      if (!this.entryResizeState) return;
      document.removeEventListener("mousemove", this.onEntryResize);
      document.removeEventListener("mouseup", this.stopEntryResize);
      this.entryResizeState = null;
    },
    entryListRowHeight() {
      const el = this.refElement("entryList");
      const firstRow = el && el.querySelector ? el.querySelector(".entry-strip-row") : null;
      if (firstRow && firstRow.offsetHeight) return Math.max(18, firstRow.offsetHeight + 3);
      return 36;
    },
    fetchGuardStats(force) {
      const requestRoomId = this.resolvedRoomId;
      const requestAnchorUid = this.roomAnchorUid() || DEFAULT_ANCHOR_UID;
      this.guardLoading = true;
      if (force) this.guardError = "";
      post("/api/live-guards/monthly", {
        force_sync: force ? 1 : 0,
        room_id: requestRoomId,
        ruid: requestAnchorUid,
      })
        .then(res => {
          if (!res.data || res.data.code !== 1001) {
            throw new Error((res.data && res.data.msg) || "舰长统计加载失败");
          }
          if (Number(requestRoomId) !== Number(this.resolvedRoomId)) return;
          this.applyGuardStats(res.data.data || {});
        })
        .catch(() => {
          if (Number(requestRoomId) !== Number(DEFAULT_ROOM_ID)) {
            throw new Error("当前房间暂无舰长统计");
          }
          return post("/api/getgift", { force_sync: force ? 1 : 0 }).then(res => {
            if (!res.data || res.data.code !== 1001) {
              throw new Error((res.data && res.data.msg) || "舰长统计加载失败");
            }
            if (Number(requestRoomId) !== Number(this.resolvedRoomId)) return;
            this.applyGuardStats({
              ...(res.data.guard_summary || {}),
              list: res.data.guard_list || [],
            });
          });
        })
        .catch(err => {
          this.guardError = err && err.message ? err.message : "舰长统计加载失败";
        })
        .finally(() => {
          this.guardLoading = false;
        });
    },
    applyGuardStats(payload) {
      const data = payload || {};
      this.guardStats = data;
      this.guardList = Array.isArray(data.list) ? data.list : [];
      this.guardError = data.error || "";
    },
    guardLevelText(item) {
      if (!item) return "";
      if (item.level_text) return item.level_text;
      const levels = Array.isArray(item.levels) ? item.levels : [];
      return levels.length ? levels.join("+") : "舰长";
    },
    guardLevelAmount(item, level) {
      const levels = Array.isArray(item && item.levels) ? item.levels : [];
      const times = (item && item.level_times) || {};
      const aliases = {
        governor: ["总督", "governor", "Governor", "總督"],
        admiral: ["提督", "admiral", "Admiral"],
        captain: ["舰长", "captain", "Captain", "艦長"],
      }[level] || [];
      for (let i = 0; i < aliases.length; i += 1) {
        const key = aliases[i];
        const value = times[key];
        if (Array.isArray(value)) return value.length;
        if (value && typeof value === "object" && value.count) return Number(value.count || 0);
        if (value) return 1;
        if (levels.indexOf(key) >= 0) return 1;
      }
      return Number((item && item[level + "_count"]) || 0);
    },
    guardLevelBadges(item) {
      return [
        { key: "governor", type: 1, title: "总督", count: this.guardLevelAmount(item, "governor") },
        { key: "admiral", type: 2, title: "提督", count: this.guardLevelAmount(item, "admiral") },
        { key: "captain", type: 3, title: "舰长", count: this.guardLevelAmount(item, "captain") },
      ].filter(level => level.count > 0);
    },
    guardAvatar(item) {
      if (!item) return NO_FACE;
      const base = (((item.uinfo || {}).base) || {});
      const uid = item.uid || base.uid || "";
      return this.normalizeUrl(item.avatar || item.face || item.user_face || base.face || this.cachedAvatar(uid)) ||
        (uid ? `${LAPLACE_WORKERS}/bilibili/avatar/${encodeURIComponent(uid)}?size=320` : NO_FACE);
    },
    guardMedal(item) {
      const raw = (item && item.raw && typeof item.raw === "object") ? item.raw : {};
      const medal = (item && (item.medal || item.medal_info || item.fans_medal)) || raw.medal_info || raw.fans_medal || {};
      const guardLevel = Number((item && (item.guard_level || item.guardType)) || medal.guard_level || medal.guardLevel || 0);
      return {
        ...medal,
        name: medal.name || medal.medal_name || medal.medalName || "",
        level: Number(medal.level || medal.medal_level || medal.medalLevel || 0),
        guardType: guardLevel,
        guard_level: guardLevel,
      };
    },
    guardPerkLevel(item) {
      const medal = this.guardMedal(item);
      const raw = (item && item.raw && typeof item.raw === "object") ? item.raw : {};
      return Number(
        medal.resolvedPerkLevel ||
        (item && (item.perkLevel || item.perk_level || item.guard_sub_level)) ||
        raw.guard_sub_level ||
        1
      );
    },
    guardDisplayDays(item) {
      return Number((item && item.companionDaysText) || (item && item.companion_days) || this.guardCompanionDays(item) || 0);
    },
    guardCompanionDays(item) {
      if (!item) return 0;
      const raw = (item.raw && typeof item.raw === "object") ? item.raw : {};
      const candidates = [
        item.companion_days,
        item.total_days,
        item.totalDays,
        item.toastTotalCount,
        item.toast_total_count,
        item.accompany,
        item.guard_days,
        item.guardDays,
        item.accompany_days,
        item.accompanyDays,
        item.days,
        raw.companion_days,
        raw.accompany,
        raw.total_days,
        raw.totalDays,
        raw.toastTotalCount,
        raw.toast_total_count,
        raw.guard_days,
        raw.guardDays,
        raw.accompany_days,
        raw.accompanyDays,
        raw.days,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const value = Number(candidates[i] || 0);
        if (Number.isFinite(value) && value > 0) return Math.floor(value);
      }
      const text = String(item.message || item.toastText || raw.message || raw.toastText || "");
      const match = text.match(/(?:第|陪伴主播(?:的第)?\s*)(\d+)\s*天/);
      return match ? Number(match[1] || 0) : 0;
    },
    guardUserTitle(item) {
      return [
        item && (item.username || item.uid),
        item && item.uid ? "UID " + item.uid : "",
        item ? this.guardLevelText(item) : "",
        this.guardDisplayDays(item) ? "陪伴 " + this.guardDisplayDays(item) + " 天" : "",
        item && item.first_time ? item.first_time : "",
      ].filter(Boolean).join(" / ");
    },
    onlineRankPreviewTitle(item, index) {
      return [
        "第 " + (index + 1) + " 名",
        item && (item.name || item.username || item.uid),
        item && item.uid ? "UID " + item.uid : "",
        "贡献值 " + this.formatNumber((item && item.value) || 0),
      ].filter(Boolean).join(" / ");
    },
    guardLevelCount(level) {
      const stats = this.guardStats || {};
      const counts = stats.unique_level_counts || stats.event_counts || {};
      if (level === "captain") return Number(stats.captain_count || stats.captain || counts["舰长"] || counts.captain || 0);
      if (level === "admiral") return Number(stats.admiral_count || stats.admiral || counts["提督"] || counts.admiral || 0);
      if (level === "governor") return Number(stats.governor_count || stats.governor || counts["总督"] || counts.governor || 0);
      return 0;
    },
    guardExportPeriod() {
      const stats = this.guardStats || {};
      const now = new Date();
      const year = Number(stats.year || now.getFullYear());
      const month = Number(stats.month || (now.getMonth() + 1));
      return `${year}.${String(month).padStart(2, "0")}`;
    },
    guardExportRoomName() {
      const option = (this.roomOptions || []).find(item => String(item.value) === String(this.resolvedRoomId));
      return (this.room && (this.room.uname || this.room.name)) || (option && option.label) || String(this.resolvedRoomId || "");
    },
    safeExportFilePart(value) {
      return String(value || "")
        .replace(/[\\/:*?"<>|]/g, "_")
        .replace(/\s+/g, " ")
        .trim();
    },
    guardExportName(item) {
      const base = (((item || {}).uinfo || {}).base) || {};
      return (item && (item.username || item.uname || item.name || item.user_name)) || base.name || "";
    },
    guardExportUid(item) {
      const base = (((item || {}).uinfo || {}).base) || {};
      return (item && (item.uid || item.mid || item.user_id)) || base.uid || "";
    },
    guardExportRows(level) {
      return this.sortedGuardList
        .map(item => ({
          item,
          count: this.guardLevelAmount(item, level),
        }))
        .filter(row => row.count > 0)
        .sort((a, b) => {
          if (b.count !== a.count) return b.count - a.count;
          const shipnumDiff = Number((b.item || {}).shipnum || 0) - Number((a.item || {}).shipnum || 0);
          if (shipnumDiff) return shipnumDiff;
          return String(this.guardExportName(a.item)).localeCompare(String(this.guardExportName(b.item)), "zh-Hans-CN");
        });
    },
    escapeExcelHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    downloadExcelHtml(filename, html) {
      const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
    exportGuardListExcel() {
      const period = this.guardExportPeriod();
      const roomName = this.guardExportRoomName();
      const fileRoomName = this.safeExportFilePart(roomName);
      const sections = [
        { title: "总督列表", level: "governor", countTitle: "本月上的总督数量" },
        { title: "提督列表", level: "admiral", countTitle: "本月上的提督数量" },
        { title: "舰长列表", level: "captain", countTitle: "本月上的舰长数量" },
      ];
      const rows = [[`${roomName} ${period} 上舰列表`]];
      const merges = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }];
      sections.forEach(section => {
        const sectionRows = this.guardExportRows(section.level);
        rows.push([]);
        merges.push({ s: { r: rows.length, c: 0 }, e: { r: rows.length, c: 2 } });
        rows.push([section.title]);
        rows.push(["用户名", "uid", section.countTitle]);
        if (!sectionRows.length) {
          rows.push(["暂无", "", ""]);
          return;
        }
        sectionRows.forEach(row => {
          rows.push([this.guardExportName(row.item) || "未知用户", String(this.guardExportUid(row.item) || ""), Number(row.count || 0)]);
        });
      });
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = [{ wch: 24 }, { wch: 18 }, { wch: 22 }];
      worksheet["!merges"] = merges;
      Object.keys(worksheet).forEach(key => {
        if (key[0] === "!") return;
        worksheet[key].s = {
          font: { name: "Microsoft YaHei", sz: key === "A1" ? 18 : 13, bold: key === "A1" || /^[A-C]\d+$/.test(key) && rows[Number(key.replace(/[A-Z]/g, "")) - 1]?.length === 3 },
          alignment: { vertical: "center" },
        };
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "上舰列表");
      XLSX.writeFile(workbook, `${fileRoomName ? fileRoomName + " " : ""}${period} 上舰列表.xlsx`, { bookType: "xlsx" });
    },
    cleanEventMessage(message) {
      return String(message || "")
        .replace(/<%([^%]+)%>/g, "$1")
        .replace(/\s+/g, " ")
        .trim();
    },
    interactionActionText(...values) {
      const candidates = values
        .flatMap(value => Array.isArray(value) ? value : [value])
        .map(value => String(value == null ? "" : value).trim())
        .filter(Boolean);
      for (const candidate of candidates) {
        const numericText = this.interactionActionCodeText(candidate);
        if (numericText) return numericText;
        const value = candidate.toLowerCase();
        if (value.indexOf("follow") >= 0 || value.indexOf("关注") >= 0) return "关注了主播";
        if (value.indexOf("share") >= 0 || value.indexOf("分享") >= 0) return "分享了直播间";
        if (value.indexOf("like") >= 0 || value.indexOf("点赞") >= 0) return "点赞了直播间";
        if (value.indexOf("enter") >= 0 || value.indexOf("entry") >= 0 || value.indexOf("进入") >= 0 || value.indexOf("入场") >= 0) return "进入直播间";
      }
      if (candidates.some(value => this.isNumericInteractionCode(value))) return "直播间互动";
      return candidates[0] || "进入直播间";
    },
    interactionActionCodeText(value) {
      const key = String(value == null ? "" : value).trim();
      const map = {
        "1": "进入直播间",
        "2": "关注了主播",
        "3": "分享了直播间",
      };
      return map[key] || "";
    },
    isNumericInteractionCode(value) {
      return /^\d+$/.test(String(value == null ? "" : value).trim());
    },
    rebuildUserCache(events) {
      const next = Object.assign({}, this.userCache);
      events.forEach(item => {
        if (!item || !item.uid) return;
        next[item.uid] = {
          username: item.username || (next[item.uid] || {}).username || "",
          avatar: item.avatar || (next[item.uid] || {}).avatar || "",
        };
      });
      this.userCache = next;
    },
    rememberUser(item) {
      if (!item || !item.uid) return;
      const cached = this.userCache[item.uid] || {};
      this.$set(this.userCache, item.uid, {
        username: item.username || cached.username || "",
        avatar: item.avatar || cached.avatar || "",
      });
    },
    cachedAvatar(uid) {
      const cached = this.userCache[String(uid || "")] || {};
      return cached.avatar || "";
    },
    avatarSrc(item) {
      return this.normalizeUrl(item.avatar || this.cachedAvatar(item.uid)) || NO_FACE;
    },
    avatarFrameSrc(item) {
      return this.normalizeUrl(item.avatarFrame || "");
    },
    resizeBiliImage(url, size) {
      const value = this.normalizeUrl(url);
      if (!value || value.indexOf("hdslb.com") < 0 || /@\d+w_\d+h/.test(value)) return value;
      return `${value}@${size}w_${size}h`;
    },
    hideBrokenImage(event) {
      if (event && event.target) event.target.style.display = "none";
    },
    useGiftFallback(event) {
      if (!event || !event.target) return;
      if (event.target.src === GIFT_FALLBACK) {
        event.target.style.display = "none";
        return;
      }
      event.target.src = GIFT_FALLBACK;
    },
    isUrl(value) {
      return /^https?:\/\//.test(String(value || ""));
    },
    wealthLevel(item) {
      return Number(item.wealthMedalLevel || item.wealthLevel || 0);
    },
    medalText(item) {
      const medal = item.medal || {};
      const name = medal.name || medal.medal_name || medal.medalName || "";
      const level = medal.level || medal.medal_level || medal.medalLevel || 0;
      return name ? name + " " + level : "";
    },
    medalName(item) {
      const medal = item.medal || {};
      return medal.name || medal.medal_name || medal.medalName || "";
    },
    medalLevel(item) {
      const medal = item.medal || {};
      return medal.level || medal.medal_level || medal.medalLevel || 0;
    },
    guardLevel(item) {
      const medal = item.medal || {};
      return Number(item.guardType || medal.guardType || medal.guard_level || medal.guardLevel || 0);
    },
    guardName(level) {
      const value = Number(level || 0);
      if (value === 3) return "舰长";
      if (value === 2) return "提督";
      if (value === 1) return "总督";
      return "";
    },
    guardText(item) {
      return item.guardName || this.guardName(this.guardLevel(item));
    },
    guardClass(item) {
      const level = this.guardLevel(item);
      return level ? "guard-level--" + level : "guard-level--0";
    },
    perkLevel(item) {
      const medal = item.medal || {};
      return Number(medal.resolvedPerkLevel || item.perkLevel || 1);
    },
    guardBadgeClass(item) {
      return [
        "guard-badge-in-meta",
        "guard-badge",
        "guard-badge--" + this.guardLevel(item),
        "perk-level--" + this.perkLevel(item),
      ];
    },
    userLevel(item) {
      return Number(item.userLvl || item.userLevel || 0);
    },
    userLevelColor(item) {
      const raw = item.userLvlBorder || item.userLevelBorder || "";
      if (!raw) return "#94a3b8";
      const value = String(raw).replace(/^#/, "");
      if (/^[0-9a-fA-F]{6}$/.test(value)) return "#" + value;
      return "#94a3b8";
    },
    usernameColor(item) {
      return item.nameColor || "";
    },
    replyUid(item) {
      const reply = item.reply || {};
      return reply.uid || "";
    },
    replyName(item) {
      const reply = item.reply || {};
      return reply.uname || reply.username || "";
    },
    messageParts(item) {
      const message = String((item && item.message) || "");
      if (item && item.emote && item.emote.url) {
        return [{ type: "image", url: this.normalizeUrl(item.emote.url), alt: message, className: "emote" }];
      }
      const bmotes = item && item.bmotes && typeof item.bmotes === "object" ? item.bmotes : null;
      if (!message || !bmotes) return message ? [{ type: "text", value: message }] : [];
      const keys = Object.keys(bmotes).filter(Boolean).sort((a, b) => b.length - a.length);
      if (!keys.length) return [{ type: "text", value: message }];
      const parts = [];
      let cursor = 0;
      while (cursor < message.length) {
        const hit = keys.find(key => message.slice(cursor, cursor + key.length) === key);
        if (hit) {
          const data = bmotes[hit] || {};
          const url = this.normalizeUrl(typeof data === "string" ? data : (data.url || data.gif_url || data.web_url || ""));
          if (url) parts.push({ type: "image", url, alt: hit, className: "bmote" });
          else parts.push({ type: "text", value: hit });
          cursor += hit.length;
        } else {
          let next = cursor + 1;
          while (next < message.length && !keys.some(key => message.slice(next, next + key.length) === key)) next += 1;
          parts.push({ type: "text", value: message.slice(cursor, next) });
          cursor = next;
        }
      }
      return parts;
    },
    priceRank(item) {
      const amount = this.eventAmount(item);
      if (amount >= 50 && amount < 100) return 2;
      if (amount >= 100 && amount < 500) return 3;
      if (amount >= 500 && amount < 1000) return 4;
      if (amount >= 1000 && amount < 2000) return 5;
      if (amount >= 2000) return 6;
      return 1;
    },
    priceRankClass(item) {
      return "event-price-rank--" + this.priceRank(item);
    },
    eventClass(item, showAs) {
      const typeMap = {
        danmu: "message",
        sc: "superchat",
        gift: "gift",
        toast: "toast",
        entry: item.cmd === "entry-effect" ? "entry-effect" : "interaction",
        lottery: item.cmd || "lottery",
        "red-envelope": item.cmd || "red-envelope",
        rank: "online-rank-update",
        stat: "watched-update",
        misc: item.cmd || "misc",
      };
      const eventType = typeMap[item.type] || item.cmd || item.type || "message";
      const classes = [
        "event",
        "event--" + eventType,
        "event-type--" + eventType,
        "event-show-as--" + (showAs || "normal"),
        "origin--" + (item.origin || this.resolvedRoomId || 0),
        "origin-index--" + (item.originIdx || 0),
        this.guardClass(item),
      ];
      if (this.isEventRead(item)) classes.push("read");
      if (item.type === "gift" || item.type === "toast" || item.type === "sc" || item.type === "red-envelope" || item.type === "lottery") {
        classes.push(this.priceRankClass(item));
      }
      if (item.type === "sc") {
        classes.push("event-superchat-rank--" + this.priceRank(item));
        classes.push("event-superchat-id--" + (item.scId || 0));
        if (Number(item.priceNormalized || item.amount || 0) < 30) classes.push("special-promo");
        if (item.guardBackground) classes.push("has-guard-bg");
        if (item.deleted) classes.push("deleted");
        if (item.messageTrans) classes.push("has-translation");
      }
      if (item.type === "gift") {
        classes.push("event-gift-rank--" + this.priceRank(item));
        classes.push("event-gift-id--" + (item.giftId || 0));
        classes.push("event-gift-type--" + (this.isPaidGift(item) ? "paid" : "free"));
      }
      if (item.type === "toast") {
        classes.push("avatar-frame-rank--" + this.toastFrameRank(item));
        classes.push("avatar-badge-rank--" + this.toastBadgeRank(item));
        if (Number(item.priceNormalized || 0) <= 50) classes.push("special-blind-box");
        if (item.mockPrice) classes.push("mock-price");
      }
      if (this.isHighlightEvent(item)) classes.push("event-size--highlight");
      else if (item.type === "gift") classes.push("event-size--normal");
      if (item.type === "entry" && item.action) classes.push("event-action--" + String(item.action).toLowerCase());
      if (item.type === "entry" && item.business) classes.push("event-business--" + item.business);
      if (item.type === "entry" && this.entryBackground(item)) classes.push("has-entry-bg");
      return classes;
    },
    eventStyle(item) {
      const style = this.sideEventStyle(item);
      if (item.type === "sc") {
        Object.assign(style, this.scStyle(item));
        style["--inline-avatar-url"] = `url(${this.avatarSrc(item)})`;
      }
      if (item.type === "toast" && item.toastColor) {
        style["--event-toast-bg"] = item.toastColor;
        style["--event-toast-bg-" + (item.toastType || this.guardLevel(item) || 3)] = item.toastColor;
      }
      return style;
    },
    entryStripStyle(item) {
      const style = {};
      if (item && item.textColor) style.color = item.textColor;
      return style;
    },
    eventAmount(item) {
      if (!item) return 0;
      if (item.type === "gift" && item.blindGift) {
        return Number(item.blindGift.gift_tip_price || 0) * Number(item.giftAmount || 1) / 1000;
      }
      return Number(item.amount || item.priceNormalized || 0);
    },
    isHighlightEvent(item) {
      return item && ((item.type === "gift" && this.isPaidGift(item) && this.eventAmount(item) > 29.99) || item.type === "toast" || item.type === "red-envelope" || item.type === "lottery");
    },
    isPaidGift(item) {
      return String((item && item.coinType) || "").toLowerCase() !== "silver";
    },
    giftIconSrc(item) {
      const icon = this.normalizeUrl(item && item.giftIcon);
      if (icon) return this.resizeBiliImage(icon, this.isHighlightEvent(item) ? 960 : 320);
      if (item && item.giftId) {
        return `${LAPLACE_WORKERS}/bilibili/room-gift-config/${item.origin || this.resolvedRoomId}?gift=${item.giftId}&size=${this.isHighlightEvent(item) ? 960 : 320}`;
      }
      return GIFT_FALLBACK;
    },
    giftPriceText(item) {
      if (!this.isPaidGift(item)) return `${this.formatMoneyFigure(this.eventAmount(item))} 银瓜子`;
      return this.formatMoneyFigure(this.eventAmount(item));
    },
    giftActionText(item) {
      if (!item) return "礼物";
      const action = item.giftAction || item.message || "投喂";
      const name = item.blindGiftName ? `${item.giftName}（${item.blindGiftName}）` : item.giftName;
      return [action, name].filter(Boolean).join(" ");
    },
    toastRankInfo(total) {
      const value = Number(total || 0);
      return {
        frameRank: value >= 10000 ? 3 : value >= 1000 ? 2 : 1,
        badgeRank: value >= 1000 ? 2 : 1,
      };
    },
    toastFrameRank(item) {
      return this.toastRankInfo(item && item.toastTotalCount).frameRank;
    },
    toastBadgeRank(item) {
      return this.toastRankInfo(item && item.toastTotalCount).badgeRank;
    },
    toastAction(item) {
      const message = String((item && item.message) || "");
      if (message.indexOf("续费") >= 0) return "续费";
      if (message.indexOf("开通") >= 0) return "开通";
      return item && item.toastAmount > 1 ? "续费" : "开通";
    },
    toastAmountUnitText(item) {
      const unit = (item && item.toastAmountUnit) || "月";
      return unit === "月" ? "个月" : unit;
    },
    toastTotalDays(item) {
      if (!item) return 0;
      if (item.toastTotalCount) return Number(item.toastTotalCount || 0);
      const match = String(item.message || "").match(/第(\d+)天|陪伴主播的第(\d+)天|陪伴主播\s*(\d+)\s*天/);
      return match ? Number(match[1] || match[2] || match[3] || 0) : 0;
    },
    entryBackground(item) {
      return this.normalizeUrl((item && (item.backgroundAnimated || item.background)) || "");
    },
    extractEntryBackground(data) {
      const urls = [];
      const visit = value => {
        if (!value) return;
        if (typeof value === "string") {
          if (/^https?:\/\//.test(value) || value.indexOf("bfs/") >= 0 || value.indexOf("//") === 0) urls.push(value);
          return;
        }
        if (Array.isArray(value)) {
          value.forEach(visit);
          return;
        }
        if (typeof value === "object") {
          [
            "mobile_dynamic_url",
            "web_dynamic_url",
            "dynamic_url",
            "web_basemap_url",
            "basemap_url",
            "background",
            "img_url",
            "url",
          ].forEach(key => visit(value[key]));
          Object.keys(value).forEach(key => {
            if (["mobile_dynamic_url", "web_dynamic_url", "dynamic_url", "web_basemap_url", "basemap_url", "background", "img_url", "url"].indexOf(key) < 0) {
              visit(value[key]);
            }
          });
        }
      };
      visit(data && data.copy_writing_v2);
      visit(data && data.copy_writing_v2_items);
      const normalized = urls.map(this.normalizeUrl).filter(Boolean);
      return {
        dynamic: normalized.find(url => /\.(webp|gif)(\?|$)/i.test(url)) || normalized[0] || "",
        static: normalized.find(url => /\.(png|jpe?g)(\?|$)/i.test(url)) || normalized[0] || "",
      };
    },
    isStickyEvent(item) {
      if (item.type === "sc" || item.type === "toast") return true;
      if (item.type === "red-envelope" || item.type === "lottery") return true;
      return this.eventAmount(item) >= 30;
    },
    showEventAvatar(item) {
      return item.showAvatar !== false;
    },
    stickyText(item) {
      if (item.type === "sc") return item.username || "Super Chat";
      if (item.type === "toast") return item.giftName || item.guardName || "舰长";
      if (item.type === "gift") return item.giftName || item.message || "礼物";
      if (item.type === "red-envelope") return "红包";
      if (item.type === "lottery") return item.giftName || "天选时刻";
      return item.message || item.username || item.type;
    },
    giftEventClass(item) {
      if (item.cmd === "USER_TOAST_MSG" || item.cmd === "GUARD_BUY" || /舰长|提督|总督/.test(item.giftName || item.message || "")) {
        return "event--toast";
      }
      return "event--gift";
    },
    giftSizeClass(item) {
      return Number(item.amount || 0) >= 30 ? "event-size--large" : "event-size--normal";
    },
    sideEventClass(item) {
      const classes = ["side-event", "event", "event-show-as--normal", this.priceRankClass(item)];
      if (item.type === "lottery") classes.push("event--lottery");
      else if (item.type === "red-envelope") classes.push("event--red-envelope");
      else if (item.type === "rank") classes.push("event--rank");
      else if (item.type === "stat") classes.push("event--stat");
      else if (item.type === "entry") classes.push("event--interaction", this.guardClass(item));
      else classes.push(this.giftEventClass(item), this.giftSizeClass(item), this.guardClass(item));
      return classes;
    },
    sideEventStyle(item) {
      const style = {};
      if (item.type === "entry") {
        const background = item.backgroundAnimated || item.background || "";
        if (background) {
          style.backgroundImage = `linear-gradient(90deg, rgba(29, 78, 216, 0.62), rgba(8, 127, 243, 0.34)), url("${background}")`;
        }
        if (item.textColor) style.color = item.textColor;
      }
      if (item.type === "toast" && item.toastColor) {
        style["--event-toast-bg"] = item.toastColor;
        style["--event-toast-bg-" + (item.toastType || this.guardLevel(item) || 3)] = item.toastColor;
      }
      return style;
    },
    sideEventText(item) {
      if (item.type === "toast") {
        const days = item.toastTotalCount ? `，已陪伴主播 ${item.toastTotalCount} 天` : "";
        return `${item.message || "开通舰长"}${days}`;
      }
      if (item.type === "entry") {
        const message = String(item.message || "").trim();
        const actionText = this.interactionActionText(
          item.msgType,
          item.action,
          item.relation,
          message,
          item.raw && item.raw.msg_type,
          item.raw && item.raw.action,
          item.raw && item.raw.relation,
          item.raw && item.raw.data && item.raw.data.msg_type,
          item.raw && item.raw.data && item.raw.data.action,
          item.raw && item.raw.data && item.raw.data.relation
        );
        if (!message || this.isNumericInteractionCode(message)) return actionText;
        return message;
      }
      if (item.type === "red-envelope") return item.message || item.giftName || "红包事件";
      if (item.type === "lottery") return item.message || item.giftName || "天选时刻";
      return item.blindGiftName ? `${item.giftName}（${item.blindGiftName}）` : (item.giftName || item.message || "礼物");
    },
    displayMessage(item) {
      const message = String(item && item.message ? item.message : "");
      if (!message) return "";
      if (item.emotes && item.emotes.length && /^\[[^\]]+\]$/.test(message.trim())) return "";
      return message;
    },
    shortUid(uid) {
      const value = String(uid || "");
      if (value.length <= 6) return "UID " + value;
      return "UID " + value.slice(-6);
    },
    currentRank(item) {
      return Number((item && item.raw && item.raw.currentRank) || item.currentRank || 0);
    },
    eventTitle(item) {
      const parts = [];
      if (item && item.username) parts.push(item.username);
      if (item && item.uid) parts.push("UID " + item.uid);
      if (item && item.timeMs) parts.push(this.formatClock(item.timeMs));
      return parts.join(" · ");
    },
    lotteryWinners(item) {
      return item.winners || [];
    },
    redEnvelopeSenderVisible(item) {
      return !!(item && (item.username || item.uid || item.avatar));
    },
    filterEvents(events) {
      const key = this.keyword.trim().toLowerCase();
      if (!key) return events;
      return events.filter(item => {
        const text = [
          item.uid,
          item.username,
          item.message,
          item.giftName,
          this.medalText(item),
        ].join(" ").toLowerCase();
        return text.indexOf(key) >= 0;
      });
    },
    filterGiftAmount(events) {
      const min = Math.max(0, Number(this.giftMinAmount || 0));
      return (events || []).filter(item => {
        if (!this.isGiftPanelEvent(item)) return false;
        if (item.type === "lottery" || item.type === "red-envelope") return true;
        const amount = this.eventAmount(item);
        return amount > 0 && amount >= min;
      });
    },
    isTodayEvent(item) {
      if (!item || !item.timeMs) return false;
      const date = new Date(item.timeMs);
      const now = new Date();
      return date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();
    },
    formatGiftMinAmount() {
      const value = Math.max(0, Number(this.giftMinAmount || 0));
      this.giftMinAmount = value.toFixed(2);
    },
    normalizeLimit(value, fallback, max) {
      const num = Number(value);
      const fallbackValue = Math.max(1, Math.floor(Number(fallback) || 1));
      const maxValue = Number.isFinite(Number(max)) && Number(max) > 0 ? Math.floor(Number(max)) : Infinity;
      if (!Number.isFinite(num) || num <= 0) return Math.min(fallbackValue, maxValue);
      return Math.min(maxValue, Math.max(1, Math.floor(num)));
    },
    clampPanelLimit(panel) {
      const config = {
        danmu: { key: "danmuLimit", fallback: 120, max: PANEL_EVENT_LIMITS.danmu },
        sc: { key: "scLimit", fallback: 80, max: PANEL_EVENT_LIMITS.sc },
        gift: { key: "giftLimit", fallback: 320, max: PANEL_EVENT_LIMITS.gift },
      }[panel];
      if (!config) return;
      this[config.key] = this.normalizeLimit(this[config.key], config.fallback, config.max);
    },
    describeEventPayload(item) {
      const fields = [
        item.type,
        item.cmd,
        item.action,
        item.giftName,
        item.toastName,
        item.rewardName,
        item.username,
        item.uid ? "UID " + item.uid : "",
      ].filter(Boolean);
      return fields.length ? fields.join(" / ") : "未识别事件";
    },
    buildRank(events, valueGetter) {
      const map = {};
      events.forEach(item => {
        const uid = String(item.uid || item.username || "");
        if (!uid) return;
        if (!map[uid]) {
          map[uid] = {
            uid,
            name: item.username || uid,
            avatar: this.avatarSrc(item),
            value: 0,
          };
        }
        map[uid].value += Number(valueGetter(item) || 0);
      });
      return Object.keys(map).map(key => map[key]).sort((a, b) => b.value - a.value);
    },
    uniqueUserCount(events) {
      const map = {};
      (events || []).forEach(item => {
        const key = String(item.uid || item.username || "");
        if (key) map[key] = true;
      });
      return Object.keys(map).length;
    },
    normalizePrice(price, amount) {
      const raw = Number(price || 0);
      const num = Number(amount || 1);
      if (!raw) return 0;
      return raw >= 1000 ? raw * num / 1000 : raw * num;
    },
    timestampMs(item) {
      const raw = Number(item.timestampNormalized || item.timestamp || Date.now());
      return raw > 1000000000000 ? raw : raw * 1000;
    },
    entryMessage(cmd, data) {
      if (cmd === "INTERACT_WORD") {
        return this.interactionActionText(data.msg_type, data.action, data.relation, data.relation_type);
      }
      if (cmd === "WELCOME_GUARD") return "舰长进入直播间";
      if (cmd === "ENTRY_EFFECT") return data.copy_writing || "高能进场";
      return "进入直播间";
    },
    scStyle(item) {
      const style = {};
      if (item.backgroundColor) style["--event-superchat-guard-bg"] = item.backgroundColor;
      return style;
    },
    formatMoney(value) {
      return "¥" + Number(value || 0).toFixed(2);
    },
    formatMoneyFigure(value) {
      const num = Number(value || 0);
      if (!Number.isFinite(num)) return "0";
      return Number.isInteger(num) ? String(num) : num.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
    },
    formatNumber(value) {
      const num = Number(value || 0);
      if (num >= 10000) return (num / 10000).toFixed(1) + "万";
      return String(num);
    },
    formatClock(value) {
      if (!value) return "-";
      return new Date(value).toLocaleTimeString("zh-CN", { hour12: false });
    },
    relativeTime(value) {
      if (!value) return "-";
      const seconds = Math.max(0, Math.floor((Date.now() - Number(value)) / 1000));
      const minute = 60;
      const hour = 60 * minute;
      const day = 24 * hour;
      const month = 30 * day;
      const year = 365 * day;
      if (seconds >= year) return Math.floor(seconds / year) + " 年前";
      if (seconds >= month) return Math.floor(seconds / month) + " 个月前";
      if (seconds >= day) return Math.floor(seconds / day) + " 天前";
      if (seconds >= hour) return Math.floor(seconds / hour) + " 小时前";
      if (seconds >= minute) return Math.floor(seconds / minute) + " 分钟前";
      return seconds + " 秒前";
    },
    escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    renderInlineMarkdown(value) {
      return this.escapeHtml(value)
        .replace(/`([^`]+)`/g, "<code>$1</code>")
        .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    },
    renderMarkdown(markdown) {
      const lines = String(markdown || "").split(/\r?\n/);
      const html = [];
      let inList = false;
      const closeList = () => {
        if (inList) {
          html.push("</ul>");
          inList = false;
        }
      };
      lines.forEach(line => {
        const text = line.trim();
        if (!text) {
          closeList();
          return;
        }
        if (text.startsWith("### ")) {
          closeList();
          html.push(`<h3>${this.renderInlineMarkdown(text.slice(4))}</h3>`);
          return;
        }
        if (text.startsWith("## ")) {
          closeList();
          html.push(`<h2>${this.renderInlineMarkdown(text.slice(3))}</h2>`);
          return;
        }
        if (text.startsWith("# ")) {
          closeList();
          html.push(`<h1>${this.renderInlineMarkdown(text.slice(2))}</h1>`);
          return;
        }
        if (text.startsWith("- ")) {
          if (!inList) {
            html.push("<ul>");
            inList = true;
          }
          html.push(`<li>${this.renderInlineMarkdown(text.slice(2))}</li>`);
          return;
        }
        closeList();
        html.push(`<p>${this.renderInlineMarkdown(text)}</p>`);
      });
      closeList();
      return html.join("");
    },
    normalizeUrl(url) {
      const value = String(url || "").trim();
      if (!value) return "";
      if (value.startsWith("//")) return "https:" + value;
      if (value.startsWith("http://")) return "https://" + value.slice(7);
      if (value.startsWith("bfs/")) return "https://i0.hdslb.com/" + value;
      return value;
    },
  },
};
</script>

<style src="./appDanmuConsole.css"></style>
